/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChatRouteRouteImport } from './routes/chat/route'
import { Route as IntegrationRouteRouteImport } from './routes/integration/route'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as ActivityIndexRouteImport } from './routes/activity/index'
import { Route as ActivityTrailIndexRouteImport } from './routes/activityTrail/index'
import { Route as ApikeyIndexRouteImport } from './routes/apikey/index'
import { Route as AreaIndexRouteImport } from './routes/area/index'
import { Route as AreaManagementIndexRouteImport } from './routes/areaManagement/index'
import { Route as AssignAccountsIndexRouteImport } from './routes/assignAccounts/index'
import { Route as BetaUsersIndexRouteImport } from './routes/betaUsers/index'
import { Route as CalendarIndexRouteImport } from './routes/calendar/index'
import { Route as CloneToolIndexRouteImport } from './routes/cloneTool/index'
import { Route as ClosersIndexRouteImport } from './routes/closers/index'
import { Route as CompaniesIndexRouteImport } from './routes/companies/index'
import { Route as CompetitionIndexRouteImport } from './routes/competition/index'
import { Route as CompetitionGameIdRouteRouteImport } from './routes/competition_.$gameId/route'
import { Route as ComplianceIndexRouteImport } from './routes/compliance/index'
import { Route as ConversationsIndexRouteImport } from './routes/conversations/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DemoToolsIndexRouteImport } from './routes/demo-tools/index'
import { Route as DnkIndexRouteImport } from './routes/dnk/index'
import { Route as ExportIndexRouteImport } from './routes/export/index'
import { Route as FeatureIndexRouteImport } from './routes/feature/index'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as ImportIndexRouteImport } from './routes/import/index'
import { Route as IntegrationCliRouteRouteImport } from './routes/integration.cli/route'
import { Route as LocationListRouteRouteImport } from './routes/location.list/route'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LogoutIndexRouteImport } from './routes/logout/index'
import { Route as ManageAccountsIndexRouteImport } from './routes/manageAccounts/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as PreferencesIndexRouteImport } from './routes/preferences/index'
import { Route as ProgramIndexRouteImport } from './routes/program/index'
import { Route as ProgramProgramIdRouteRouteImport } from './routes/program_.$programId/route'
import { Route as ProspectingIndexRouteImport } from './routes/prospecting/index'
import { Route as QuestionsIndexRouteImport } from './routes/questions/index'
import { Route as QuizIndexRouteImport } from './routes/quiz/index'
import { Route as QuizQuizIdRouteRouteImport } from './routes/quiz_.$quizId/route'
import { Route as RecordingsIndexRouteImport } from './routes/recordings/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as SampleComponentsIndexRouteImport } from './routes/sampleComponents/index'
import { Route as SettingsRoleRouteRouteImport } from './routes/settings.role/route'
import { Route as StatsIndexRouteImport } from './routes/stats/index'
import { Route as TeamIndexRouteImport } from './routes/team/index'
import { Route as UserIndexRouteImport } from './routes/user/index'
import { Route as WebhookIndexRouteImport } from './routes/webhook/index'
import { Route as AccountAccountIdIndexRouteImport } from './routes/account_.$accountId/index'
import { Route as AccountAddIndexRouteImport } from './routes/account_.add/index'
import { Route as AreaManagementTrashIndexRouteImport } from './routes/areaManagement_.trash/index'
import { Route as AttachmentAttachmentIdIndexRouteImport } from './routes/attachment.$attachmentId/index'
import { Route as BetausersUserIdIndexRouteImport } from './routes/betausers_.$userId/index'
import { Route as CalendarEventIdIndexRouteImport } from './routes/calendar.$eventId/index'
import { Route as CalendarCloserAvailabilityIndexRouteImport } from './routes/calendar_.closerAvailability/index'
import { Route as ChatSessionIdIndexRouteImport } from './routes/chat.$sessionId/index'
import { Route as CompaniesCompanyIdIndexRouteImport } from './routes/companies_.$companyId/index'
import { Route as CompaniesAddIndexRouteImport } from './routes/companies_.add/index'
import { Route as CompetitionAddIndexRouteImport } from './routes/competition_.add/index'
import { Route as CompetitionTrashIndexRouteImport } from './routes/competition_.trash/index'
import { Route as CompliancePolicyIndexRouteImport } from './routes/compliance_.policy/index'
import { Route as ComplianceViolationsIndexRouteImport } from './routes/compliance_.violations/index'
import { Route as ConversationsConvoIdIndexRouteImport } from './routes/conversations_.$convoId/index'
import { Route as ConversationsFlaggedIndexRouteImport } from './routes/conversations_.flagged/index'
import { Route as ConversationsSkillShareIndexRouteImport } from './routes/conversations_.skillShare/index'
import { Route as DashboardDashboardIdEditRouteRouteImport } from './routes/dashboard_.$dashboardId_.edit/route'
import { Route as FeatureFeatureIdIndexRouteImport } from './routes/feature_.$featureId/index'
import { Route as IntegrationApikeyIndexRouteImport } from './routes/integration.apikey/index'
import { Route as IntegrationDeveloperIndexRouteImport } from './routes/integration.developer/index'
import { Route as IntegrationExportIndexRouteImport } from './routes/integration.export/index'
import { Route as IntegrationImportIndexRouteImport } from './routes/integration.import/index'
import { Route as IntegrationMarketplaceIndexRouteImport } from './routes/integration.marketplace/index'
import { Route as IntegrationMarketplaceAppIdRouteRouteImport } from './routes/integration.marketplace_.$appId/route'
import { Route as IntegrationMcpIndexRouteImport } from './routes/integration.mcp/index'
import { Route as IntegrationWebhookIndexRouteImport } from './routes/integration.webhook/index'
import { Route as LocationAuditIndexRouteImport } from './routes/location.audit/index'
import { Route as LocationGeocodeIndexRouteImport } from './routes/location.geocode/index'
import { Route as ProgramTrashIndexRouteImport } from './routes/program_.trash/index'
import { Route as QuestionsQuestionIdIndexRouteImport } from './routes/questions_.$questionId/index'
import { Route as QuestionsAddIndexRouteImport } from './routes/questions_.add/index'
import { Route as QuestionsTrashIndexRouteImport } from './routes/questions_.trash/index'
import { Route as QuizTrashIndexRouteImport } from './routes/quiz_.trash/index'
import { Route as RecordingsRecordingIdIndexRouteImport } from './routes/recordings_.$recordingId/index'
import { Route as SettingsAiIndexRouteImport } from './routes/settings.ai/index'
import { Route as SettingsApikeyIndexRouteImport } from './routes/settings.apikey/index'
import { Route as SettingsCommunicationPreferencesIndexRouteImport } from './routes/settings.communicationPreferences/index'
import { Route as SettingsCompanyIndexRouteImport } from './routes/settings.company/index'
import { Route as SettingsConfigurationIndexRouteImport } from './routes/settings.configuration/index'
import { Route as SettingsCustomFieldIndexRouteImport } from './routes/settings.customField/index'
import { Route as SettingsDispositionIndexRouteImport } from './routes/settings.disposition/index'
import { Route as SettingsLinksIndexRouteImport } from './routes/settings.links/index'
import { Route as SettingsMyCardIndexRouteImport } from './routes/settings.myCard/index'
import { Route as SettingsOutcomeIndexRouteImport } from './routes/settings.outcome/index'
import { Route as SettingsPermissionsIndexRouteImport } from './routes/settings.permissions/index'
import { Route as SettingsRatiosIndexRouteImport } from './routes/settings.ratios/index'
import { Route as SettingsRoleIndexRouteImport } from './routes/settings.role/index'
import { Route as SettingsScorecardIndexRouteImport } from './routes/settings.scorecard/index'
import { Route as SettingsStatusIndexRouteImport } from './routes/settings.status/index'
import { Route as SettingsTileIndexRouteImport } from './routes/settings.tile/index'
import { Route as SettingsWebhookIndexRouteImport } from './routes/settings.webhook/index'
import { Route as SettingsWorkflowIndexRouteImport } from './routes/settings.workflow/index'
import { Route as ShortReportsIndexRouteImport } from './routes/short.reports/index'
import { Route as ShortUploadIndexRouteImport } from './routes/short.upload/index'
import { Route as ShortVideoIdIndexRouteImport } from './routes/short_.$videoId/index'
import { Route as StatsMapIndexRouteImport } from './routes/stats_.map/index'
import { Route as SunrunOktaUsersIndexRouteImport } from './routes/sunrun_.oktaUsers/index'
import { Route as TaskManagementIndexRouteImport } from './routes/task.management/index'
import { Route as TaskManagersIndexRouteImport } from './routes/task.managers/index'
import { Route as TaskTroubleshootIndexRouteImport } from './routes/task.troubleshoot/index'
import { Route as TeamTeamIdIndexRouteImport } from './routes/team_.$teamId/index'
import { Route as TeamAddIndexRouteImport } from './routes/team_.add/index'
import { Route as TeamTrashIndexRouteImport } from './routes/team_.trash/index'
import { Route as UserUserIdIndexRouteImport } from './routes/user_.$userId/index'
import { Route as UserAddIndexRouteImport } from './routes/user_.add/index'
import { Route as UserTrashIndexRouteImport } from './routes/user_.trash/index'
import { Route as BetausersUserIdEditIndexRouteImport } from './routes/betausers_.$userId.edit/index'
import { Route as CompaniesCompanyIdManageIndexRouteImport } from './routes/companies_.$companyId_.manage/index'
import { Route as CompaniesCompanyIdUserIndexRouteImport } from './routes/companies_.$companyId_.user/index'
import { Route as CompetitionGameIdBracketIndexRouteImport } from './routes/competition_.$gameId.bracket/index'
import { Route as CompetitionGameIdMarketingIndexRouteImport } from './routes/competition_.$gameId.marketing/index'
import { Route as CompetitionGameIdParticipantIndexRouteImport } from './routes/competition_.$gameId.participant/index'
import { Route as CompetitionGameIdPrizeIndexRouteImport } from './routes/competition_.$gameId.prize/index'
import { Route as CompetitionGameIdScoringIndexRouteImport } from './routes/competition_.$gameId.scoring/index'
import { Route as CompetitionGameIdSummaryIndexRouteImport } from './routes/competition_.$gameId.summary/index'
import { Route as CompetitionGameIdTimelineIndexRouteImport } from './routes/competition_.$gameId.timeline/index'
import { Route as CompetitionGameIdViewIndexRouteImport } from './routes/competition_.$gameId_.view/index'
import { Route as CompliancePolicyPolicyIdIndexRouteImport } from './routes/compliance_.policy_.$policyId/index'
import { Route as CompliancePolicyAddIndexRouteImport } from './routes/compliance_.policy_.add/index'
import { Route as ComplianceViolationViolationIdIndexRouteImport } from './routes/compliance_.violation_.$violationId/index'
import { Route as ComplianceViolationsEntityIdIndexRouteImport } from './routes/compliance_.violations_.$entityId/index'
import { Route as DashboardDashboardIdEditIndexRouteImport } from './routes/dashboard_.$dashboardId_.edit/index'
import { Route as IntegrationDeveloperAppIdIndexRouteImport } from './routes/integration.developer_.$appId/index'
import { Route as IntegrationImportImportIdIndexRouteImport } from './routes/integration.import_.$importId/index'
import { Route as IntegrationImportAddIndexRouteImport } from './routes/integration.import_.add/index'
import { Route as IntegrationMarketplaceAppIdIndexRouteImport } from './routes/integration.marketplace_.$appId/index'
import { Route as IntegrationWebhookWebhookIdIndexRouteImport } from './routes/integration.webhook_.$webhookId/index'
import { Route as LocationListCustomLocationIdIndexRouteImport } from './routes/location.list/$customLocationId/index'
import { Route as ProgramProgramIdSetupIndexRouteImport } from './routes/program_.$programId.setup/index'
import { Route as ProgramProgramIdSummaryIndexRouteImport } from './routes/program_.$programId.summary/index'
import { Route as ProgramProgramIdTasksIndexRouteImport } from './routes/program_.$programId.tasks/index'
import { Route as ProgramProgramIdUsersIndexRouteImport } from './routes/program_.$programId.users/index'
import { Route as ProgramProgramIdViewIndexRouteImport } from './routes/program_.$programId_.view/index'
import { Route as QuestionsQuestionIdEditIndexRouteImport } from './routes/questions_.$questionId_.edit/index'
import { Route as QuizQuizIdAssigneesIndexRouteImport } from './routes/quiz_.$quizId.assignees/index'
import { Route as QuizQuizIdQuestionsIndexRouteImport } from './routes/quiz_.$quizId.questions/index'
import { Route as QuizQuizIdSettingsIndexRouteImport } from './routes/quiz_.$quizId.settings/index'
import { Route as QuizQuizIdSummaryIndexRouteImport } from './routes/quiz_.$quizId.summary/index'
import { Route as SettingsCompanyUserIndexRouteImport } from './routes/settings.company_.user/index'
import { Route as SettingsCustomFieldFieldIdIndexRouteImport } from './routes/settings.customField_.$fieldId/index'
import { Route as SettingsCustomFieldAddIndexRouteImport } from './routes/settings.customField_.add/index'
import { Route as SettingsCustomFieldTrashIndexRouteImport } from './routes/settings.customField_.trash/index'
import { Route as SettingsDispositionDispositionIdIndexRouteImport } from './routes/settings.disposition_.$dispositionId/index'
import { Route as SettingsDispositionAddIndexRouteImport } from './routes/settings.disposition_.add/index'
import { Route as SettingsLinksExternalLinkIdIndexRouteImport } from './routes/settings.links_.$externalLinkId/index'
import { Route as SettingsLinksAddIndexRouteImport } from './routes/settings.links_.add/index'
import { Route as SettingsOutcomeOutcomeIdIndexRouteImport } from './routes/settings.outcome_.$outcomeId/index'
import { Route as SettingsOutcomeAddIndexRouteImport } from './routes/settings.outcome_.add/index'
import { Route as SettingsPermissionsCompareIndexRouteImport } from './routes/settings.permissions/compare/index'
import { Route as SettingsRoleRoleIdIndexRouteImport } from './routes/settings.role.$roleId/index'
import { Route as SettingsRoleAddIndexRouteImport } from './routes/settings.role.add/index'
import { Route as SettingsRoleTrashIndexRouteImport } from './routes/settings.role.trash/index'
import { Route as SettingsScorecardRubricIdIndexRouteImport } from './routes/settings.scorecard_.$rubricId/index'
import { Route as SettingsScorecardAddIndexRouteImport } from './routes/settings.scorecard_.add/index'
import { Route as SettingsScorecardTrashIndexRouteImport } from './routes/settings.scorecard_.trash/index'
import { Route as SettingsStatusStatusIdIndexRouteImport } from './routes/settings.status_.$statusId/index'
import { Route as SettingsStatusAddIndexRouteImport } from './routes/settings.status_.add/index'
import { Route as SettingsWorkflowWorkflowIdIndexRouteImport } from './routes/settings.workflow_.$workflowId/index'
import { Route as ShortReportsVideoIdIndexRouteImport } from './routes/short.reports_.$videoId/index'
import { Route as TaskManagersManagerIdIndexRouteImport } from './routes/task.managers_.$managerId/index'
import { Route as TeamTeamIdUserIdIndexRouteImport } from './routes/team_.$teamId_.$userId/index'
import { Route as UserUserIdEditIndexRouteImport } from './routes/user_.$userId_.edit/index'
import { Route as CompaniesCompanyIdUserUserIdIndexRouteImport } from './routes/companies_.$companyId_.user_.$userId/index'
import { Route as CompaniesCompanyIdUserAddIndexRouteImport } from './routes/companies_.$companyId_.user_.add/index'
import { Route as CompaniesCompanyIdUserTrashIndexRouteImport } from './routes/companies_.$companyId_.user_.trash/index'
import { Route as IntegrationDeveloperAppIdScriptIdIndexRouteImport } from './routes/integration.developer_.$appId_.$scriptId/index'
import { Route as IntegrationMarketplaceAppIdInstallIdIndexRouteImport } from './routes/integration.marketplace_.$appId.$installId/index'
import { Route as IntegrationMarketplaceAppIdDocumentationIndexRouteImport } from './routes/integration.marketplace_.$appId.documentation/index'
import { Route as SettingsCompanyUserAddIndexRouteImport } from './routes/settings.company_.user_.add/index'
import { Route as SettingsCompanyUserTrashIndexRouteImport } from './routes/settings.company_.user_.trash/index'
import { Route as TeamTeamIdUserIdEditIndexRouteImport } from './routes/team_.$teamId_.$userId.edit/index'
import { Route as CompaniesCompanyIdUserUserIdEditIndexRouteImport } from './routes/companies_.$companyId_.user_.$userId_.edit/index'
import { Route as IntegrationMarketplaceAppIdInstallIdMetricsIndexRouteImport } from './routes/integration.marketplace_.$appId.$installId_.metrics/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRouteRoute = ChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationRouteRoute = IntegrationRouteRouteImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityIndexRoute = ActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityTrailIndexRoute = ActivityTrailIndexRouteImport.update({
  id: '/activityTrail/',
  path: '/activityTrail/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApikeyIndexRoute = ApikeyIndexRouteImport.update({
  id: '/apikey/',
  path: '/apikey/',
  getParentRoute: () => rootRouteImport,
} as any)
const AreaIndexRoute = AreaIndexRouteImport.update({
  id: '/area/',
  path: '/area/',
  getParentRoute: () => rootRouteImport,
} as any)
const AreaManagementIndexRoute = AreaManagementIndexRouteImport.update({
  id: '/areaManagement/',
  path: '/areaManagement/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssignAccountsIndexRoute = AssignAccountsIndexRouteImport.update({
  id: '/assignAccounts/',
  path: '/assignAccounts/',
  getParentRoute: () => rootRouteImport,
} as any)
const BetaUsersIndexRoute = BetaUsersIndexRouteImport.update({
  id: '/betaUsers/',
  path: '/betaUsers/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarIndexRoute = CalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => rootRouteImport,
} as any)
const CloneToolIndexRoute = CloneToolIndexRouteImport.update({
  id: '/cloneTool/',
  path: '/cloneTool/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClosersIndexRoute = ClosersIndexRouteImport.update({
  id: '/closers/',
  path: '/closers/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesIndexRoute = CompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetitionIndexRoute = CompetitionIndexRouteImport.update({
  id: '/competition/',
  path: '/competition/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetitionGameIdRouteRoute = CompetitionGameIdRouteRouteImport.update({
  id: '/competition_/$gameId',
  path: '/competition/$gameId',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceIndexRoute = ComplianceIndexRouteImport.update({
  id: '/compliance/',
  path: '/compliance/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationsIndexRoute = ConversationsIndexRouteImport.update({
  id: '/conversations/',
  path: '/conversations/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoToolsIndexRoute = DemoToolsIndexRouteImport.update({
  id: '/demo-tools/',
  path: '/demo-tools/',
  getParentRoute: () => rootRouteImport,
} as any)
const DnkIndexRoute = DnkIndexRouteImport.update({
  id: '/dnk/',
  path: '/dnk/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportIndexRoute = ExportIndexRouteImport.update({
  id: '/export/',
  path: '/export/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeatureIndexRoute = FeatureIndexRouteImport.update({
  id: '/feature/',
  path: '/feature/',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportIndexRoute = ImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationCliRouteRoute = IntegrationCliRouteRouteImport.update({
  id: '/cli',
  path: '/cli',
  getParentRoute: () => IntegrationRouteRoute,
} as any)
const LocationListRouteRoute = LocationListRouteRouteImport.update({
  id: '/location/list',
  path: '/location/list',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutIndexRoute = LogoutIndexRouteImport.update({
  id: '/logout/',
  path: '/logout/',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageAccountsIndexRoute = ManageAccountsIndexRouteImport.update({
  id: '/manageAccounts/',
  path: '/manageAccounts/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const PreferencesIndexRoute = PreferencesIndexRouteImport.update({
  id: '/preferences/',
  path: '/preferences/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramIndexRoute = ProgramIndexRouteImport.update({
  id: '/program/',
  path: '/program/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramProgramIdRouteRoute = ProgramProgramIdRouteRouteImport.update({
  id: '/program_/$programId',
  path: '/program/$programId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProspectingIndexRoute = ProspectingIndexRouteImport.update({
  id: '/prospecting/',
  path: '/prospecting/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestionsIndexRoute = QuestionsIndexRouteImport.update({
  id: '/questions/',
  path: '/questions/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuizIndexRoute = QuizIndexRouteImport.update({
  id: '/quiz/',
  path: '/quiz/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuizQuizIdRouteRoute = QuizQuizIdRouteRouteImport.update({
  id: '/quiz_/$quizId',
  path: '/quiz/$quizId',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsIndexRoute = RecordingsIndexRouteImport.update({
  id: '/recordings/',
  path: '/recordings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const SampleComponentsIndexRoute = SampleComponentsIndexRouteImport.update({
  id: '/sampleComponents/',
  path: '/sampleComponents/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoleRouteRoute = SettingsRoleRouteRouteImport.update({
  id: '/role',
  path: '/role',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const StatsIndexRoute = StatsIndexRouteImport.update({
  id: '/stats/',
  path: '/stats/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserIndexRoute = UserIndexRouteImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhookIndexRoute = WebhookIndexRouteImport.update({
  id: '/webhook/',
  path: '/webhook/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountAccountIdIndexRoute = AccountAccountIdIndexRouteImport.update({
  id: '/account_/$accountId/',
  path: '/account/$accountId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountAddIndexRoute = AccountAddIndexRouteImport.update({
  id: '/account_/add/',
  path: '/account/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const AreaManagementTrashIndexRoute =
  AreaManagementTrashIndexRouteImport.update({
    id: '/areaManagement_/trash/',
    path: '/areaManagement/trash/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AttachmentAttachmentIdIndexRoute =
  AttachmentAttachmentIdIndexRouteImport.update({
    id: '/attachment/$attachmentId/',
    path: '/attachment/$attachmentId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BetausersUserIdIndexRoute = BetausersUserIdIndexRouteImport.update({
  id: '/betausers_/$userId/',
  path: '/betausers/$userId/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarEventIdIndexRoute = CalendarEventIdIndexRouteImport.update({
  id: '/calendar/$eventId/',
  path: '/calendar/$eventId/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarCloserAvailabilityIndexRoute =
  CalendarCloserAvailabilityIndexRouteImport.update({
    id: '/calendar_/closerAvailability/',
    path: '/calendar/closerAvailability/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ChatSessionIdIndexRoute = ChatSessionIdIndexRouteImport.update({
  id: '/$sessionId/',
  path: '/$sessionId/',
  getParentRoute: () => ChatRouteRoute,
} as any)
const CompaniesCompanyIdIndexRoute = CompaniesCompanyIdIndexRouteImport.update({
  id: '/companies_/$companyId/',
  path: '/companies/$companyId/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesAddIndexRoute = CompaniesAddIndexRouteImport.update({
  id: '/companies_/add/',
  path: '/companies/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetitionAddIndexRoute = CompetitionAddIndexRouteImport.update({
  id: '/competition_/add/',
  path: '/competition/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetitionTrashIndexRoute = CompetitionTrashIndexRouteImport.update({
  id: '/competition_/trash/',
  path: '/competition/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompliancePolicyIndexRoute = CompliancePolicyIndexRouteImport.update({
  id: '/compliance_/policy/',
  path: '/compliance/policy/',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceViolationsIndexRoute =
  ComplianceViolationsIndexRouteImport.update({
    id: '/compliance_/violations/',
    path: '/compliance/violations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConversationsConvoIdIndexRoute =
  ConversationsConvoIdIndexRouteImport.update({
    id: '/conversations_/$convoId/',
    path: '/conversations/$convoId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConversationsFlaggedIndexRoute =
  ConversationsFlaggedIndexRouteImport.update({
    id: '/conversations_/flagged/',
    path: '/conversations/flagged/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConversationsSkillShareIndexRoute =
  ConversationsSkillShareIndexRouteImport.update({
    id: '/conversations_/skillShare/',
    path: '/conversations/skillShare/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardDashboardIdEditRouteRoute =
  DashboardDashboardIdEditRouteRouteImport.update({
    id: '/dashboard_/$dashboardId_/edit',
    path: '/dashboard/$dashboardId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const FeatureFeatureIdIndexRoute = FeatureFeatureIdIndexRouteImport.update({
  id: '/feature_/$featureId/',
  path: '/feature/$featureId/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationApikeyIndexRoute = IntegrationApikeyIndexRouteImport.update({
  id: '/apikey/',
  path: '/apikey/',
  getParentRoute: () => IntegrationRouteRoute,
} as any)
const IntegrationDeveloperIndexRoute =
  IntegrationDeveloperIndexRouteImport.update({
    id: '/developer/',
    path: '/developer/',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const IntegrationExportIndexRoute = IntegrationExportIndexRouteImport.update({
  id: '/export/',
  path: '/export/',
  getParentRoute: () => IntegrationRouteRoute,
} as any)
const IntegrationImportIndexRoute = IntegrationImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => IntegrationRouteRoute,
} as any)
const IntegrationMarketplaceIndexRoute =
  IntegrationMarketplaceIndexRouteImport.update({
    id: '/marketplace/',
    path: '/marketplace/',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const IntegrationMarketplaceAppIdRouteRoute =
  IntegrationMarketplaceAppIdRouteRouteImport.update({
    id: '/marketplace_/$appId',
    path: '/marketplace/$appId',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const IntegrationMcpIndexRoute = IntegrationMcpIndexRouteImport.update({
  id: '/mcp/',
  path: '/mcp/',
  getParentRoute: () => IntegrationRouteRoute,
} as any)
const IntegrationWebhookIndexRoute = IntegrationWebhookIndexRouteImport.update({
  id: '/webhook/',
  path: '/webhook/',
  getParentRoute: () => IntegrationRouteRoute,
} as any)
const LocationAuditIndexRoute = LocationAuditIndexRouteImport.update({
  id: '/location/audit/',
  path: '/location/audit/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationGeocodeIndexRoute = LocationGeocodeIndexRouteImport.update({
  id: '/location/geocode/',
  path: '/location/geocode/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramTrashIndexRoute = ProgramTrashIndexRouteImport.update({
  id: '/program_/trash/',
  path: '/program/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestionsQuestionIdIndexRoute =
  QuestionsQuestionIdIndexRouteImport.update({
    id: '/questions_/$questionId/',
    path: '/questions/$questionId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const QuestionsAddIndexRoute = QuestionsAddIndexRouteImport.update({
  id: '/questions_/add/',
  path: '/questions/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestionsTrashIndexRoute = QuestionsTrashIndexRouteImport.update({
  id: '/questions_/trash/',
  path: '/questions/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuizTrashIndexRoute = QuizTrashIndexRouteImport.update({
  id: '/quiz_/trash/',
  path: '/quiz/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsRecordingIdIndexRoute =
  RecordingsRecordingIdIndexRouteImport.update({
    id: '/recordings_/$recordingId/',
    path: '/recordings/$recordingId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAiIndexRoute = SettingsAiIndexRouteImport.update({
  id: '/ai/',
  path: '/ai/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsApikeyIndexRoute = SettingsApikeyIndexRouteImport.update({
  id: '/apikey/',
  path: '/apikey/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsCommunicationPreferencesIndexRoute =
  SettingsCommunicationPreferencesIndexRouteImport.update({
    id: '/communicationPreferences/',
    path: '/communicationPreferences/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsCompanyIndexRoute = SettingsCompanyIndexRouteImport.update({
  id: '/company/',
  path: '/company/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsConfigurationIndexRoute =
  SettingsConfigurationIndexRouteImport.update({
    id: '/configuration/',
    path: '/configuration/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsCustomFieldIndexRoute =
  SettingsCustomFieldIndexRouteImport.update({
    id: '/customField/',
    path: '/customField/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsDispositionIndexRoute =
  SettingsDispositionIndexRouteImport.update({
    id: '/disposition/',
    path: '/disposition/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsLinksIndexRoute = SettingsLinksIndexRouteImport.update({
  id: '/links/',
  path: '/links/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMyCardIndexRoute = SettingsMyCardIndexRouteImport.update({
  id: '/myCard/',
  path: '/myCard/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsOutcomeIndexRoute = SettingsOutcomeIndexRouteImport.update({
  id: '/outcome/',
  path: '/outcome/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsPermissionsIndexRoute =
  SettingsPermissionsIndexRouteImport.update({
    id: '/permissions/',
    path: '/permissions/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsRatiosIndexRoute = SettingsRatiosIndexRouteImport.update({
  id: '/ratios/',
  path: '/ratios/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsRoleIndexRoute = SettingsRoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoleRouteRoute,
} as any)
const SettingsScorecardIndexRoute = SettingsScorecardIndexRouteImport.update({
  id: '/scorecard/',
  path: '/scorecard/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsStatusIndexRoute = SettingsStatusIndexRouteImport.update({
  id: '/status/',
  path: '/status/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsTileIndexRoute = SettingsTileIndexRouteImport.update({
  id: '/tile/',
  path: '/tile/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsWebhookIndexRoute = SettingsWebhookIndexRouteImport.update({
  id: '/webhook/',
  path: '/webhook/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsWorkflowIndexRoute = SettingsWorkflowIndexRouteImport.update({
  id: '/workflow/',
  path: '/workflow/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const ShortReportsIndexRoute = ShortReportsIndexRouteImport.update({
  id: '/short/reports/',
  path: '/short/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShortUploadIndexRoute = ShortUploadIndexRouteImport.update({
  id: '/short/upload/',
  path: '/short/upload/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShortVideoIdIndexRoute = ShortVideoIdIndexRouteImport.update({
  id: '/short_/$videoId/',
  path: '/short/$videoId/',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsMapIndexRoute = StatsMapIndexRouteImport.update({
  id: '/stats_/map/',
  path: '/stats/map/',
  getParentRoute: () => rootRouteImport,
} as any)
const SunrunOktaUsersIndexRoute = SunrunOktaUsersIndexRouteImport.update({
  id: '/sunrun_/oktaUsers/',
  path: '/sunrun/oktaUsers/',
  getParentRoute: () => rootRouteImport,
} as any)
const TaskManagementIndexRoute = TaskManagementIndexRouteImport.update({
  id: '/task/management/',
  path: '/task/management/',
  getParentRoute: () => rootRouteImport,
} as any)
const TaskManagersIndexRoute = TaskManagersIndexRouteImport.update({
  id: '/task/managers/',
  path: '/task/managers/',
  getParentRoute: () => rootRouteImport,
} as any)
const TaskTroubleshootIndexRoute = TaskTroubleshootIndexRouteImport.update({
  id: '/task/troubleshoot/',
  path: '/task/troubleshoot/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamTeamIdIndexRoute = TeamTeamIdIndexRouteImport.update({
  id: '/team_/$teamId/',
  path: '/team/$teamId/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamAddIndexRoute = TeamAddIndexRouteImport.update({
  id: '/team_/add/',
  path: '/team/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamTrashIndexRoute = TeamTrashIndexRouteImport.update({
  id: '/team_/trash/',
  path: '/team/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdIndexRoute = UserUserIdIndexRouteImport.update({
  id: '/user_/$userId/',
  path: '/user/$userId/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAddIndexRoute = UserAddIndexRouteImport.update({
  id: '/user_/add/',
  path: '/user/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserTrashIndexRoute = UserTrashIndexRouteImport.update({
  id: '/user_/trash/',
  path: '/user/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const BetausersUserIdEditIndexRoute =
  BetausersUserIdEditIndexRouteImport.update({
    id: '/betausers_/$userId/edit/',
    path: '/betausers/$userId/edit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompaniesCompanyIdManageIndexRoute =
  CompaniesCompanyIdManageIndexRouteImport.update({
    id: '/companies_/$companyId_/manage/',
    path: '/companies/$companyId/manage/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompaniesCompanyIdUserIndexRoute =
  CompaniesCompanyIdUserIndexRouteImport.update({
    id: '/companies_/$companyId_/user/',
    path: '/companies/$companyId/user/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompetitionGameIdBracketIndexRoute =
  CompetitionGameIdBracketIndexRouteImport.update({
    id: '/bracket/',
    path: '/bracket/',
    getParentRoute: () => CompetitionGameIdRouteRoute,
  } as any)
const CompetitionGameIdMarketingIndexRoute =
  CompetitionGameIdMarketingIndexRouteImport.update({
    id: '/marketing/',
    path: '/marketing/',
    getParentRoute: () => CompetitionGameIdRouteRoute,
  } as any)
const CompetitionGameIdParticipantIndexRoute =
  CompetitionGameIdParticipantIndexRouteImport.update({
    id: '/participant/',
    path: '/participant/',
    getParentRoute: () => CompetitionGameIdRouteRoute,
  } as any)
const CompetitionGameIdPrizeIndexRoute =
  CompetitionGameIdPrizeIndexRouteImport.update({
    id: '/prize/',
    path: '/prize/',
    getParentRoute: () => CompetitionGameIdRouteRoute,
  } as any)
const CompetitionGameIdScoringIndexRoute =
  CompetitionGameIdScoringIndexRouteImport.update({
    id: '/scoring/',
    path: '/scoring/',
    getParentRoute: () => CompetitionGameIdRouteRoute,
  } as any)
const CompetitionGameIdSummaryIndexRoute =
  CompetitionGameIdSummaryIndexRouteImport.update({
    id: '/summary/',
    path: '/summary/',
    getParentRoute: () => CompetitionGameIdRouteRoute,
  } as any)
const CompetitionGameIdTimelineIndexRoute =
  CompetitionGameIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => CompetitionGameIdRouteRoute,
  } as any)
const CompetitionGameIdViewIndexRoute =
  CompetitionGameIdViewIndexRouteImport.update({
    id: '/competition_/$gameId_/view/',
    path: '/competition/$gameId/view/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompliancePolicyPolicyIdIndexRoute =
  CompliancePolicyPolicyIdIndexRouteImport.update({
    id: '/compliance_/policy_/$policyId/',
    path: '/compliance/policy/$policyId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompliancePolicyAddIndexRoute =
  CompliancePolicyAddIndexRouteImport.update({
    id: '/compliance_/policy_/add/',
    path: '/compliance/policy/add/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ComplianceViolationViolationIdIndexRoute =
  ComplianceViolationViolationIdIndexRouteImport.update({
    id: '/compliance_/violation_/$violationId/',
    path: '/compliance/violation/$violationId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ComplianceViolationsEntityIdIndexRoute =
  ComplianceViolationsEntityIdIndexRouteImport.update({
    id: '/compliance_/violations_/$entityId/',
    path: '/compliance/violations/$entityId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardDashboardIdEditIndexRoute =
  DashboardDashboardIdEditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardIdEditRouteRoute,
  } as any)
const IntegrationDeveloperAppIdIndexRoute =
  IntegrationDeveloperAppIdIndexRouteImport.update({
    id: '/developer_/$appId/',
    path: '/developer/$appId/',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const IntegrationImportImportIdIndexRoute =
  IntegrationImportImportIdIndexRouteImport.update({
    id: '/import_/$importId/',
    path: '/import/$importId/',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const IntegrationImportAddIndexRoute =
  IntegrationImportAddIndexRouteImport.update({
    id: '/import_/add/',
    path: '/import/add/',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const IntegrationMarketplaceAppIdIndexRoute =
  IntegrationMarketplaceAppIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IntegrationMarketplaceAppIdRouteRoute,
  } as any)
const IntegrationWebhookWebhookIdIndexRoute =
  IntegrationWebhookWebhookIdIndexRouteImport.update({
    id: '/webhook_/$webhookId/',
    path: '/webhook/$webhookId/',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const LocationListCustomLocationIdIndexRoute =
  LocationListCustomLocationIdIndexRouteImport.update({
    id: '/$customLocationId/',
    path: '/$customLocationId/',
    getParentRoute: () => LocationListRouteRoute,
  } as any)
const ProgramProgramIdSetupIndexRoute =
  ProgramProgramIdSetupIndexRouteImport.update({
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => ProgramProgramIdRouteRoute,
  } as any)
const ProgramProgramIdSummaryIndexRoute =
  ProgramProgramIdSummaryIndexRouteImport.update({
    id: '/summary/',
    path: '/summary/',
    getParentRoute: () => ProgramProgramIdRouteRoute,
  } as any)
const ProgramProgramIdTasksIndexRoute =
  ProgramProgramIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => ProgramProgramIdRouteRoute,
  } as any)
const ProgramProgramIdUsersIndexRoute =
  ProgramProgramIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => ProgramProgramIdRouteRoute,
  } as any)
const ProgramProgramIdViewIndexRoute =
  ProgramProgramIdViewIndexRouteImport.update({
    id: '/program_/$programId_/view/',
    path: '/program/$programId/view/',
    getParentRoute: () => rootRouteImport,
  } as any)
const QuestionsQuestionIdEditIndexRoute =
  QuestionsQuestionIdEditIndexRouteImport.update({
    id: '/questions_/$questionId_/edit/',
    path: '/questions/$questionId/edit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const QuizQuizIdAssigneesIndexRoute =
  QuizQuizIdAssigneesIndexRouteImport.update({
    id: '/assignees/',
    path: '/assignees/',
    getParentRoute: () => QuizQuizIdRouteRoute,
  } as any)
const QuizQuizIdQuestionsIndexRoute =
  QuizQuizIdQuestionsIndexRouteImport.update({
    id: '/questions/',
    path: '/questions/',
    getParentRoute: () => QuizQuizIdRouteRoute,
  } as any)
const QuizQuizIdSettingsIndexRoute = QuizQuizIdSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => QuizQuizIdRouteRoute,
} as any)
const QuizQuizIdSummaryIndexRoute = QuizQuizIdSummaryIndexRouteImport.update({
  id: '/summary/',
  path: '/summary/',
  getParentRoute: () => QuizQuizIdRouteRoute,
} as any)
const SettingsCompanyUserIndexRoute =
  SettingsCompanyUserIndexRouteImport.update({
    id: '/company_/user/',
    path: '/company/user/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsCustomFieldFieldIdIndexRoute =
  SettingsCustomFieldFieldIdIndexRouteImport.update({
    id: '/customField_/$fieldId/',
    path: '/customField/$fieldId/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsCustomFieldAddIndexRoute =
  SettingsCustomFieldAddIndexRouteImport.update({
    id: '/customField_/add/',
    path: '/customField/add/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsCustomFieldTrashIndexRoute =
  SettingsCustomFieldTrashIndexRouteImport.update({
    id: '/customField_/trash/',
    path: '/customField/trash/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsDispositionDispositionIdIndexRoute =
  SettingsDispositionDispositionIdIndexRouteImport.update({
    id: '/disposition_/$dispositionId/',
    path: '/disposition/$dispositionId/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsDispositionAddIndexRoute =
  SettingsDispositionAddIndexRouteImport.update({
    id: '/disposition_/add/',
    path: '/disposition/add/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsLinksExternalLinkIdIndexRoute =
  SettingsLinksExternalLinkIdIndexRouteImport.update({
    id: '/links_/$externalLinkId/',
    path: '/links/$externalLinkId/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsLinksAddIndexRoute = SettingsLinksAddIndexRouteImport.update({
  id: '/links_/add/',
  path: '/links/add/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsOutcomeOutcomeIdIndexRoute =
  SettingsOutcomeOutcomeIdIndexRouteImport.update({
    id: '/outcome_/$outcomeId/',
    path: '/outcome/$outcomeId/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsOutcomeAddIndexRoute = SettingsOutcomeAddIndexRouteImport.update({
  id: '/outcome_/add/',
  path: '/outcome/add/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsPermissionsCompareIndexRoute =
  SettingsPermissionsCompareIndexRouteImport.update({
    id: '/permissions/compare/',
    path: '/permissions/compare/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsRoleRoleIdIndexRoute = SettingsRoleRoleIdIndexRouteImport.update({
  id: '/$roleId/',
  path: '/$roleId/',
  getParentRoute: () => SettingsRoleRouteRoute,
} as any)
const SettingsRoleAddIndexRoute = SettingsRoleAddIndexRouteImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => SettingsRoleRouteRoute,
} as any)
const SettingsRoleTrashIndexRoute = SettingsRoleTrashIndexRouteImport.update({
  id: '/trash/',
  path: '/trash/',
  getParentRoute: () => SettingsRoleRouteRoute,
} as any)
const SettingsScorecardRubricIdIndexRoute =
  SettingsScorecardRubricIdIndexRouteImport.update({
    id: '/scorecard_/$rubricId/',
    path: '/scorecard/$rubricId/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsScorecardAddIndexRoute =
  SettingsScorecardAddIndexRouteImport.update({
    id: '/scorecard_/add/',
    path: '/scorecard/add/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsScorecardTrashIndexRoute =
  SettingsScorecardTrashIndexRouteImport.update({
    id: '/scorecard_/trash/',
    path: '/scorecard/trash/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsStatusStatusIdIndexRoute =
  SettingsStatusStatusIdIndexRouteImport.update({
    id: '/status_/$statusId/',
    path: '/status/$statusId/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsStatusAddIndexRoute = SettingsStatusAddIndexRouteImport.update({
  id: '/status_/add/',
  path: '/status/add/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsWorkflowWorkflowIdIndexRoute =
  SettingsWorkflowWorkflowIdIndexRouteImport.update({
    id: '/workflow_/$workflowId/',
    path: '/workflow/$workflowId/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const ShortReportsVideoIdIndexRoute =
  ShortReportsVideoIdIndexRouteImport.update({
    id: '/short/reports_/$videoId/',
    path: '/short/reports/$videoId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TaskManagersManagerIdIndexRoute =
  TaskManagersManagerIdIndexRouteImport.update({
    id: '/task/managers_/$managerId/',
    path: '/task/managers/$managerId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TeamTeamIdUserIdIndexRoute = TeamTeamIdUserIdIndexRouteImport.update({
  id: '/team_/$teamId_/$userId/',
  path: '/team/$teamId/$userId/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdEditIndexRoute = UserUserIdEditIndexRouteImport.update({
  id: '/user_/$userId_/edit/',
  path: '/user/$userId/edit/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdUserUserIdIndexRoute =
  CompaniesCompanyIdUserUserIdIndexRouteImport.update({
    id: '/companies_/$companyId_/user_/$userId/',
    path: '/companies/$companyId/user/$userId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompaniesCompanyIdUserAddIndexRoute =
  CompaniesCompanyIdUserAddIndexRouteImport.update({
    id: '/companies_/$companyId_/user_/add/',
    path: '/companies/$companyId/user/add/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompaniesCompanyIdUserTrashIndexRoute =
  CompaniesCompanyIdUserTrashIndexRouteImport.update({
    id: '/companies_/$companyId_/user_/trash/',
    path: '/companies/$companyId/user/trash/',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationDeveloperAppIdScriptIdIndexRoute =
  IntegrationDeveloperAppIdScriptIdIndexRouteImport.update({
    id: '/developer_/$appId_/$scriptId/',
    path: '/developer/$appId/$scriptId/',
    getParentRoute: () => IntegrationRouteRoute,
  } as any)
const IntegrationMarketplaceAppIdInstallIdIndexRoute =
  IntegrationMarketplaceAppIdInstallIdIndexRouteImport.update({
    id: '/$installId/',
    path: '/$installId/',
    getParentRoute: () => IntegrationMarketplaceAppIdRouteRoute,
  } as any)
const IntegrationMarketplaceAppIdDocumentationIndexRoute =
  IntegrationMarketplaceAppIdDocumentationIndexRouteImport.update({
    id: '/documentation/',
    path: '/documentation/',
    getParentRoute: () => IntegrationMarketplaceAppIdRouteRoute,
  } as any)
const SettingsCompanyUserAddIndexRoute =
  SettingsCompanyUserAddIndexRouteImport.update({
    id: '/company_/user_/add/',
    path: '/company/user/add/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsCompanyUserTrashIndexRoute =
  SettingsCompanyUserTrashIndexRouteImport.update({
    id: '/company_/user_/trash/',
    path: '/company/user/trash/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const TeamTeamIdUserIdEditIndexRoute =
  TeamTeamIdUserIdEditIndexRouteImport.update({
    id: '/team_/$teamId_/$userId/edit/',
    path: '/team/$teamId/$userId/edit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompaniesCompanyIdUserUserIdEditIndexRoute =
  CompaniesCompanyIdUserUserIdEditIndexRouteImport.update({
    id: '/companies_/$companyId_/user_/$userId_/edit/',
    path: '/companies/$companyId/user/$userId/edit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute =
  IntegrationMarketplaceAppIdInstallIdMetricsIndexRouteImport.update({
    id: '/$installId_/metrics/',
    path: '/$installId/metrics/',
    getParentRoute: () => IntegrationMarketplaceAppIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/chat': typeof ChatRouteRouteWithChildren
  '/integration': typeof IntegrationRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/competition/$gameId': typeof CompetitionGameIdRouteRouteWithChildren
  '/integration/cli': typeof IntegrationCliRouteRoute
  '/location/list': typeof LocationListRouteRouteWithChildren
  '/program/$programId': typeof ProgramProgramIdRouteRouteWithChildren
  '/quiz/$quizId': typeof QuizQuizIdRouteRouteWithChildren
  '/settings/role': typeof SettingsRoleRouteRouteWithChildren
  '/account/': typeof AccountIndexRoute
  '/activity/': typeof ActivityIndexRoute
  '/activityTrail/': typeof ActivityTrailIndexRoute
  '/apikey/': typeof ApikeyIndexRoute
  '/area/': typeof AreaIndexRoute
  '/areaManagement/': typeof AreaManagementIndexRoute
  '/assignAccounts/': typeof AssignAccountsIndexRoute
  '/betaUsers/': typeof BetaUsersIndexRoute
  '/calendar/': typeof CalendarIndexRoute
  '/cloneTool/': typeof CloneToolIndexRoute
  '/closers/': typeof ClosersIndexRoute
  '/companies/': typeof CompaniesIndexRoute
  '/competition/': typeof CompetitionIndexRoute
  '/compliance/': typeof ComplianceIndexRoute
  '/conversations/': typeof ConversationsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/demo-tools/': typeof DemoToolsIndexRoute
  '/dnk/': typeof DnkIndexRoute
  '/export/': typeof ExportIndexRoute
  '/feature/': typeof FeatureIndexRoute
  '/home/': typeof HomeIndexRoute
  '/import/': typeof ImportIndexRoute
  '/login/': typeof LoginIndexRoute
  '/logout/': typeof LogoutIndexRoute
  '/manageAccounts/': typeof ManageAccountsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/preferences/': typeof PreferencesIndexRoute
  '/program/': typeof ProgramIndexRoute
  '/prospecting/': typeof ProspectingIndexRoute
  '/questions/': typeof QuestionsIndexRoute
  '/quiz/': typeof QuizIndexRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/sampleComponents/': typeof SampleComponentsIndexRoute
  '/stats/': typeof StatsIndexRoute
  '/team/': typeof TeamIndexRoute
  '/user/': typeof UserIndexRoute
  '/webhook/': typeof WebhookIndexRoute
  '/dashboard/$dashboardId/edit': typeof DashboardDashboardIdEditRouteRouteWithChildren
  '/integration/marketplace/$appId': typeof IntegrationMarketplaceAppIdRouteRouteWithChildren
  '/account/$accountId/': typeof AccountAccountIdIndexRoute
  '/account/add/': typeof AccountAddIndexRoute
  '/areaManagement/trash/': typeof AreaManagementTrashIndexRoute
  '/attachment/$attachmentId/': typeof AttachmentAttachmentIdIndexRoute
  '/betausers/$userId/': typeof BetausersUserIdIndexRoute
  '/calendar/$eventId/': typeof CalendarEventIdIndexRoute
  '/calendar/closerAvailability/': typeof CalendarCloserAvailabilityIndexRoute
  '/chat/$sessionId/': typeof ChatSessionIdIndexRoute
  '/companies/$companyId/': typeof CompaniesCompanyIdIndexRoute
  '/companies/add/': typeof CompaniesAddIndexRoute
  '/competition/add/': typeof CompetitionAddIndexRoute
  '/competition/trash/': typeof CompetitionTrashIndexRoute
  '/compliance/policy/': typeof CompliancePolicyIndexRoute
  '/compliance/violations/': typeof ComplianceViolationsIndexRoute
  '/conversations/$convoId/': typeof ConversationsConvoIdIndexRoute
  '/conversations/flagged/': typeof ConversationsFlaggedIndexRoute
  '/conversations/skillShare/': typeof ConversationsSkillShareIndexRoute
  '/feature/$featureId/': typeof FeatureFeatureIdIndexRoute
  '/integration/apikey/': typeof IntegrationApikeyIndexRoute
  '/integration/developer/': typeof IntegrationDeveloperIndexRoute
  '/integration/export/': typeof IntegrationExportIndexRoute
  '/integration/import/': typeof IntegrationImportIndexRoute
  '/integration/marketplace/': typeof IntegrationMarketplaceIndexRoute
  '/integration/mcp/': typeof IntegrationMcpIndexRoute
  '/integration/webhook/': typeof IntegrationWebhookIndexRoute
  '/location/audit/': typeof LocationAuditIndexRoute
  '/location/geocode/': typeof LocationGeocodeIndexRoute
  '/program/trash/': typeof ProgramTrashIndexRoute
  '/questions/$questionId/': typeof QuestionsQuestionIdIndexRoute
  '/questions/add/': typeof QuestionsAddIndexRoute
  '/questions/trash/': typeof QuestionsTrashIndexRoute
  '/quiz/trash/': typeof QuizTrashIndexRoute
  '/recordings/$recordingId/': typeof RecordingsRecordingIdIndexRoute
  '/settings/ai/': typeof SettingsAiIndexRoute
  '/settings/apikey/': typeof SettingsApikeyIndexRoute
  '/settings/communicationPreferences/': typeof SettingsCommunicationPreferencesIndexRoute
  '/settings/company/': typeof SettingsCompanyIndexRoute
  '/settings/configuration/': typeof SettingsConfigurationIndexRoute
  '/settings/customField/': typeof SettingsCustomFieldIndexRoute
  '/settings/disposition/': typeof SettingsDispositionIndexRoute
  '/settings/links/': typeof SettingsLinksIndexRoute
  '/settings/myCard/': typeof SettingsMyCardIndexRoute
  '/settings/outcome/': typeof SettingsOutcomeIndexRoute
  '/settings/permissions/': typeof SettingsPermissionsIndexRoute
  '/settings/ratios/': typeof SettingsRatiosIndexRoute
  '/settings/role/': typeof SettingsRoleIndexRoute
  '/settings/scorecard/': typeof SettingsScorecardIndexRoute
  '/settings/status/': typeof SettingsStatusIndexRoute
  '/settings/tile/': typeof SettingsTileIndexRoute
  '/settings/webhook/': typeof SettingsWebhookIndexRoute
  '/settings/workflow/': typeof SettingsWorkflowIndexRoute
  '/short/reports/': typeof ShortReportsIndexRoute
  '/short/upload/': typeof ShortUploadIndexRoute
  '/short/$videoId/': typeof ShortVideoIdIndexRoute
  '/stats/map/': typeof StatsMapIndexRoute
  '/sunrun/oktaUsers/': typeof SunrunOktaUsersIndexRoute
  '/task/management/': typeof TaskManagementIndexRoute
  '/task/managers/': typeof TaskManagersIndexRoute
  '/task/troubleshoot/': typeof TaskTroubleshootIndexRoute
  '/team/$teamId/': typeof TeamTeamIdIndexRoute
  '/team/add/': typeof TeamAddIndexRoute
  '/team/trash/': typeof TeamTrashIndexRoute
  '/user/$userId/': typeof UserUserIdIndexRoute
  '/user/add/': typeof UserAddIndexRoute
  '/user/trash/': typeof UserTrashIndexRoute
  '/betausers/$userId/edit/': typeof BetausersUserIdEditIndexRoute
  '/companies/$companyId/manage/': typeof CompaniesCompanyIdManageIndexRoute
  '/companies/$companyId/user/': typeof CompaniesCompanyIdUserIndexRoute
  '/competition/$gameId/bracket/': typeof CompetitionGameIdBracketIndexRoute
  '/competition/$gameId/marketing/': typeof CompetitionGameIdMarketingIndexRoute
  '/competition/$gameId/participant/': typeof CompetitionGameIdParticipantIndexRoute
  '/competition/$gameId/prize/': typeof CompetitionGameIdPrizeIndexRoute
  '/competition/$gameId/scoring/': typeof CompetitionGameIdScoringIndexRoute
  '/competition/$gameId/summary/': typeof CompetitionGameIdSummaryIndexRoute
  '/competition/$gameId/timeline/': typeof CompetitionGameIdTimelineIndexRoute
  '/competition/$gameId/view/': typeof CompetitionGameIdViewIndexRoute
  '/compliance/policy/$policyId/': typeof CompliancePolicyPolicyIdIndexRoute
  '/compliance/policy/add/': typeof CompliancePolicyAddIndexRoute
  '/compliance/violation/$violationId/': typeof ComplianceViolationViolationIdIndexRoute
  '/compliance/violations/$entityId/': typeof ComplianceViolationsEntityIdIndexRoute
  '/dashboard/$dashboardId/edit/': typeof DashboardDashboardIdEditIndexRoute
  '/integration/developer/$appId/': typeof IntegrationDeveloperAppIdIndexRoute
  '/integration/import/$importId/': typeof IntegrationImportImportIdIndexRoute
  '/integration/import/add/': typeof IntegrationImportAddIndexRoute
  '/integration/marketplace/$appId/': typeof IntegrationMarketplaceAppIdIndexRoute
  '/integration/webhook/$webhookId/': typeof IntegrationWebhookWebhookIdIndexRoute
  '/location/list/$customLocationId/': typeof LocationListCustomLocationIdIndexRoute
  '/program/$programId/setup/': typeof ProgramProgramIdSetupIndexRoute
  '/program/$programId/summary/': typeof ProgramProgramIdSummaryIndexRoute
  '/program/$programId/tasks/': typeof ProgramProgramIdTasksIndexRoute
  '/program/$programId/users/': typeof ProgramProgramIdUsersIndexRoute
  '/program/$programId/view/': typeof ProgramProgramIdViewIndexRoute
  '/questions/$questionId/edit/': typeof QuestionsQuestionIdEditIndexRoute
  '/quiz/$quizId/assignees/': typeof QuizQuizIdAssigneesIndexRoute
  '/quiz/$quizId/questions/': typeof QuizQuizIdQuestionsIndexRoute
  '/quiz/$quizId/settings/': typeof QuizQuizIdSettingsIndexRoute
  '/quiz/$quizId/summary/': typeof QuizQuizIdSummaryIndexRoute
  '/settings/company/user/': typeof SettingsCompanyUserIndexRoute
  '/settings/customField/$fieldId/': typeof SettingsCustomFieldFieldIdIndexRoute
  '/settings/customField/add/': typeof SettingsCustomFieldAddIndexRoute
  '/settings/customField/trash/': typeof SettingsCustomFieldTrashIndexRoute
  '/settings/disposition/$dispositionId/': typeof SettingsDispositionDispositionIdIndexRoute
  '/settings/disposition/add/': typeof SettingsDispositionAddIndexRoute
  '/settings/links/$externalLinkId/': typeof SettingsLinksExternalLinkIdIndexRoute
  '/settings/links/add/': typeof SettingsLinksAddIndexRoute
  '/settings/outcome/$outcomeId/': typeof SettingsOutcomeOutcomeIdIndexRoute
  '/settings/outcome/add/': typeof SettingsOutcomeAddIndexRoute
  '/settings/permissions/compare/': typeof SettingsPermissionsCompareIndexRoute
  '/settings/role/$roleId/': typeof SettingsRoleRoleIdIndexRoute
  '/settings/role/add/': typeof SettingsRoleAddIndexRoute
  '/settings/role/trash/': typeof SettingsRoleTrashIndexRoute
  '/settings/scorecard/$rubricId/': typeof SettingsScorecardRubricIdIndexRoute
  '/settings/scorecard/add/': typeof SettingsScorecardAddIndexRoute
  '/settings/scorecard/trash/': typeof SettingsScorecardTrashIndexRoute
  '/settings/status/$statusId/': typeof SettingsStatusStatusIdIndexRoute
  '/settings/status/add/': typeof SettingsStatusAddIndexRoute
  '/settings/workflow/$workflowId/': typeof SettingsWorkflowWorkflowIdIndexRoute
  '/short/reports/$videoId/': typeof ShortReportsVideoIdIndexRoute
  '/task/managers/$managerId/': typeof TaskManagersManagerIdIndexRoute
  '/team/$teamId/$userId/': typeof TeamTeamIdUserIdIndexRoute
  '/user/$userId/edit/': typeof UserUserIdEditIndexRoute
  '/companies/$companyId/user/$userId/': typeof CompaniesCompanyIdUserUserIdIndexRoute
  '/companies/$companyId/user/add/': typeof CompaniesCompanyIdUserAddIndexRoute
  '/companies/$companyId/user/trash/': typeof CompaniesCompanyIdUserTrashIndexRoute
  '/integration/developer/$appId/$scriptId/': typeof IntegrationDeveloperAppIdScriptIdIndexRoute
  '/integration/marketplace/$appId/$installId/': typeof IntegrationMarketplaceAppIdInstallIdIndexRoute
  '/integration/marketplace/$appId/documentation/': typeof IntegrationMarketplaceAppIdDocumentationIndexRoute
  '/settings/company/user/add/': typeof SettingsCompanyUserAddIndexRoute
  '/settings/company/user/trash/': typeof SettingsCompanyUserTrashIndexRoute
  '/team/$teamId/$userId/edit/': typeof TeamTeamIdUserIdEditIndexRoute
  '/companies/$companyId/user/$userId/edit/': typeof CompaniesCompanyIdUserUserIdEditIndexRoute
  '/integration/marketplace/$appId/$installId/metrics/': typeof IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/chat': typeof ChatRouteRouteWithChildren
  '/integration': typeof IntegrationRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/competition/$gameId': typeof CompetitionGameIdRouteRouteWithChildren
  '/integration/cli': typeof IntegrationCliRouteRoute
  '/location/list': typeof LocationListRouteRouteWithChildren
  '/program/$programId': typeof ProgramProgramIdRouteRouteWithChildren
  '/quiz/$quizId': typeof QuizQuizIdRouteRouteWithChildren
  '/account': typeof AccountIndexRoute
  '/activity': typeof ActivityIndexRoute
  '/activityTrail': typeof ActivityTrailIndexRoute
  '/apikey': typeof ApikeyIndexRoute
  '/area': typeof AreaIndexRoute
  '/areaManagement': typeof AreaManagementIndexRoute
  '/assignAccounts': typeof AssignAccountsIndexRoute
  '/betaUsers': typeof BetaUsersIndexRoute
  '/calendar': typeof CalendarIndexRoute
  '/cloneTool': typeof CloneToolIndexRoute
  '/closers': typeof ClosersIndexRoute
  '/companies': typeof CompaniesIndexRoute
  '/competition': typeof CompetitionIndexRoute
  '/compliance': typeof ComplianceIndexRoute
  '/conversations': typeof ConversationsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/demo-tools': typeof DemoToolsIndexRoute
  '/dnk': typeof DnkIndexRoute
  '/export': typeof ExportIndexRoute
  '/feature': typeof FeatureIndexRoute
  '/home': typeof HomeIndexRoute
  '/import': typeof ImportIndexRoute
  '/login': typeof LoginIndexRoute
  '/logout': typeof LogoutIndexRoute
  '/manageAccounts': typeof ManageAccountsIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/preferences': typeof PreferencesIndexRoute
  '/program': typeof ProgramIndexRoute
  '/prospecting': typeof ProspectingIndexRoute
  '/questions': typeof QuestionsIndexRoute
  '/quiz': typeof QuizIndexRoute
  '/recordings': typeof RecordingsIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/sampleComponents': typeof SampleComponentsIndexRoute
  '/stats': typeof StatsIndexRoute
  '/team': typeof TeamIndexRoute
  '/user': typeof UserIndexRoute
  '/webhook': typeof WebhookIndexRoute
  '/account/$accountId': typeof AccountAccountIdIndexRoute
  '/account/add': typeof AccountAddIndexRoute
  '/areaManagement/trash': typeof AreaManagementTrashIndexRoute
  '/attachment/$attachmentId': typeof AttachmentAttachmentIdIndexRoute
  '/betausers/$userId': typeof BetausersUserIdIndexRoute
  '/calendar/$eventId': typeof CalendarEventIdIndexRoute
  '/calendar/closerAvailability': typeof CalendarCloserAvailabilityIndexRoute
  '/chat/$sessionId': typeof ChatSessionIdIndexRoute
  '/companies/$companyId': typeof CompaniesCompanyIdIndexRoute
  '/companies/add': typeof CompaniesAddIndexRoute
  '/competition/add': typeof CompetitionAddIndexRoute
  '/competition/trash': typeof CompetitionTrashIndexRoute
  '/compliance/policy': typeof CompliancePolicyIndexRoute
  '/compliance/violations': typeof ComplianceViolationsIndexRoute
  '/conversations/$convoId': typeof ConversationsConvoIdIndexRoute
  '/conversations/flagged': typeof ConversationsFlaggedIndexRoute
  '/conversations/skillShare': typeof ConversationsSkillShareIndexRoute
  '/feature/$featureId': typeof FeatureFeatureIdIndexRoute
  '/integration/apikey': typeof IntegrationApikeyIndexRoute
  '/integration/developer': typeof IntegrationDeveloperIndexRoute
  '/integration/export': typeof IntegrationExportIndexRoute
  '/integration/import': typeof IntegrationImportIndexRoute
  '/integration/marketplace': typeof IntegrationMarketplaceIndexRoute
  '/integration/mcp': typeof IntegrationMcpIndexRoute
  '/integration/webhook': typeof IntegrationWebhookIndexRoute
  '/location/audit': typeof LocationAuditIndexRoute
  '/location/geocode': typeof LocationGeocodeIndexRoute
  '/program/trash': typeof ProgramTrashIndexRoute
  '/questions/$questionId': typeof QuestionsQuestionIdIndexRoute
  '/questions/add': typeof QuestionsAddIndexRoute
  '/questions/trash': typeof QuestionsTrashIndexRoute
  '/quiz/trash': typeof QuizTrashIndexRoute
  '/recordings/$recordingId': typeof RecordingsRecordingIdIndexRoute
  '/settings/ai': typeof SettingsAiIndexRoute
  '/settings/apikey': typeof SettingsApikeyIndexRoute
  '/settings/communicationPreferences': typeof SettingsCommunicationPreferencesIndexRoute
  '/settings/company': typeof SettingsCompanyIndexRoute
  '/settings/configuration': typeof SettingsConfigurationIndexRoute
  '/settings/customField': typeof SettingsCustomFieldIndexRoute
  '/settings/disposition': typeof SettingsDispositionIndexRoute
  '/settings/links': typeof SettingsLinksIndexRoute
  '/settings/myCard': typeof SettingsMyCardIndexRoute
  '/settings/outcome': typeof SettingsOutcomeIndexRoute
  '/settings/permissions': typeof SettingsPermissionsIndexRoute
  '/settings/ratios': typeof SettingsRatiosIndexRoute
  '/settings/role': typeof SettingsRoleIndexRoute
  '/settings/scorecard': typeof SettingsScorecardIndexRoute
  '/settings/status': typeof SettingsStatusIndexRoute
  '/settings/tile': typeof SettingsTileIndexRoute
  '/settings/webhook': typeof SettingsWebhookIndexRoute
  '/settings/workflow': typeof SettingsWorkflowIndexRoute
  '/short/reports': typeof ShortReportsIndexRoute
  '/short/upload': typeof ShortUploadIndexRoute
  '/short/$videoId': typeof ShortVideoIdIndexRoute
  '/stats/map': typeof StatsMapIndexRoute
  '/sunrun/oktaUsers': typeof SunrunOktaUsersIndexRoute
  '/task/management': typeof TaskManagementIndexRoute
  '/task/managers': typeof TaskManagersIndexRoute
  '/task/troubleshoot': typeof TaskTroubleshootIndexRoute
  '/team/$teamId': typeof TeamTeamIdIndexRoute
  '/team/add': typeof TeamAddIndexRoute
  '/team/trash': typeof TeamTrashIndexRoute
  '/user/$userId': typeof UserUserIdIndexRoute
  '/user/add': typeof UserAddIndexRoute
  '/user/trash': typeof UserTrashIndexRoute
  '/betausers/$userId/edit': typeof BetausersUserIdEditIndexRoute
  '/companies/$companyId/manage': typeof CompaniesCompanyIdManageIndexRoute
  '/companies/$companyId/user': typeof CompaniesCompanyIdUserIndexRoute
  '/competition/$gameId/bracket': typeof CompetitionGameIdBracketIndexRoute
  '/competition/$gameId/marketing': typeof CompetitionGameIdMarketingIndexRoute
  '/competition/$gameId/participant': typeof CompetitionGameIdParticipantIndexRoute
  '/competition/$gameId/prize': typeof CompetitionGameIdPrizeIndexRoute
  '/competition/$gameId/scoring': typeof CompetitionGameIdScoringIndexRoute
  '/competition/$gameId/summary': typeof CompetitionGameIdSummaryIndexRoute
  '/competition/$gameId/timeline': typeof CompetitionGameIdTimelineIndexRoute
  '/competition/$gameId/view': typeof CompetitionGameIdViewIndexRoute
  '/compliance/policy/$policyId': typeof CompliancePolicyPolicyIdIndexRoute
  '/compliance/policy/add': typeof CompliancePolicyAddIndexRoute
  '/compliance/violation/$violationId': typeof ComplianceViolationViolationIdIndexRoute
  '/compliance/violations/$entityId': typeof ComplianceViolationsEntityIdIndexRoute
  '/dashboard/$dashboardId/edit': typeof DashboardDashboardIdEditIndexRoute
  '/integration/developer/$appId': typeof IntegrationDeveloperAppIdIndexRoute
  '/integration/import/$importId': typeof IntegrationImportImportIdIndexRoute
  '/integration/import/add': typeof IntegrationImportAddIndexRoute
  '/integration/marketplace/$appId': typeof IntegrationMarketplaceAppIdIndexRoute
  '/integration/webhook/$webhookId': typeof IntegrationWebhookWebhookIdIndexRoute
  '/location/list/$customLocationId': typeof LocationListCustomLocationIdIndexRoute
  '/program/$programId/setup': typeof ProgramProgramIdSetupIndexRoute
  '/program/$programId/summary': typeof ProgramProgramIdSummaryIndexRoute
  '/program/$programId/tasks': typeof ProgramProgramIdTasksIndexRoute
  '/program/$programId/users': typeof ProgramProgramIdUsersIndexRoute
  '/program/$programId/view': typeof ProgramProgramIdViewIndexRoute
  '/questions/$questionId/edit': typeof QuestionsQuestionIdEditIndexRoute
  '/quiz/$quizId/assignees': typeof QuizQuizIdAssigneesIndexRoute
  '/quiz/$quizId/questions': typeof QuizQuizIdQuestionsIndexRoute
  '/quiz/$quizId/settings': typeof QuizQuizIdSettingsIndexRoute
  '/quiz/$quizId/summary': typeof QuizQuizIdSummaryIndexRoute
  '/settings/company/user': typeof SettingsCompanyUserIndexRoute
  '/settings/customField/$fieldId': typeof SettingsCustomFieldFieldIdIndexRoute
  '/settings/customField/add': typeof SettingsCustomFieldAddIndexRoute
  '/settings/customField/trash': typeof SettingsCustomFieldTrashIndexRoute
  '/settings/disposition/$dispositionId': typeof SettingsDispositionDispositionIdIndexRoute
  '/settings/disposition/add': typeof SettingsDispositionAddIndexRoute
  '/settings/links/$externalLinkId': typeof SettingsLinksExternalLinkIdIndexRoute
  '/settings/links/add': typeof SettingsLinksAddIndexRoute
  '/settings/outcome/$outcomeId': typeof SettingsOutcomeOutcomeIdIndexRoute
  '/settings/outcome/add': typeof SettingsOutcomeAddIndexRoute
  '/settings/permissions/compare': typeof SettingsPermissionsCompareIndexRoute
  '/settings/role/$roleId': typeof SettingsRoleRoleIdIndexRoute
  '/settings/role/add': typeof SettingsRoleAddIndexRoute
  '/settings/role/trash': typeof SettingsRoleTrashIndexRoute
  '/settings/scorecard/$rubricId': typeof SettingsScorecardRubricIdIndexRoute
  '/settings/scorecard/add': typeof SettingsScorecardAddIndexRoute
  '/settings/scorecard/trash': typeof SettingsScorecardTrashIndexRoute
  '/settings/status/$statusId': typeof SettingsStatusStatusIdIndexRoute
  '/settings/status/add': typeof SettingsStatusAddIndexRoute
  '/settings/workflow/$workflowId': typeof SettingsWorkflowWorkflowIdIndexRoute
  '/short/reports/$videoId': typeof ShortReportsVideoIdIndexRoute
  '/task/managers/$managerId': typeof TaskManagersManagerIdIndexRoute
  '/team/$teamId/$userId': typeof TeamTeamIdUserIdIndexRoute
  '/user/$userId/edit': typeof UserUserIdEditIndexRoute
  '/companies/$companyId/user/$userId': typeof CompaniesCompanyIdUserUserIdIndexRoute
  '/companies/$companyId/user/add': typeof CompaniesCompanyIdUserAddIndexRoute
  '/companies/$companyId/user/trash': typeof CompaniesCompanyIdUserTrashIndexRoute
  '/integration/developer/$appId/$scriptId': typeof IntegrationDeveloperAppIdScriptIdIndexRoute
  '/integration/marketplace/$appId/$installId': typeof IntegrationMarketplaceAppIdInstallIdIndexRoute
  '/integration/marketplace/$appId/documentation': typeof IntegrationMarketplaceAppIdDocumentationIndexRoute
  '/settings/company/user/add': typeof SettingsCompanyUserAddIndexRoute
  '/settings/company/user/trash': typeof SettingsCompanyUserTrashIndexRoute
  '/team/$teamId/$userId/edit': typeof TeamTeamIdUserIdEditIndexRoute
  '/companies/$companyId/user/$userId/edit': typeof CompaniesCompanyIdUserUserIdEditIndexRoute
  '/integration/marketplace/$appId/$installId/metrics': typeof IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/chat': typeof ChatRouteRouteWithChildren
  '/integration': typeof IntegrationRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/competition_/$gameId': typeof CompetitionGameIdRouteRouteWithChildren
  '/integration/cli': typeof IntegrationCliRouteRoute
  '/location/list': typeof LocationListRouteRouteWithChildren
  '/program_/$programId': typeof ProgramProgramIdRouteRouteWithChildren
  '/quiz_/$quizId': typeof QuizQuizIdRouteRouteWithChildren
  '/settings/role': typeof SettingsRoleRouteRouteWithChildren
  '/account/': typeof AccountIndexRoute
  '/activity/': typeof ActivityIndexRoute
  '/activityTrail/': typeof ActivityTrailIndexRoute
  '/apikey/': typeof ApikeyIndexRoute
  '/area/': typeof AreaIndexRoute
  '/areaManagement/': typeof AreaManagementIndexRoute
  '/assignAccounts/': typeof AssignAccountsIndexRoute
  '/betaUsers/': typeof BetaUsersIndexRoute
  '/calendar/': typeof CalendarIndexRoute
  '/cloneTool/': typeof CloneToolIndexRoute
  '/closers/': typeof ClosersIndexRoute
  '/companies/': typeof CompaniesIndexRoute
  '/competition/': typeof CompetitionIndexRoute
  '/compliance/': typeof ComplianceIndexRoute
  '/conversations/': typeof ConversationsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/demo-tools/': typeof DemoToolsIndexRoute
  '/dnk/': typeof DnkIndexRoute
  '/export/': typeof ExportIndexRoute
  '/feature/': typeof FeatureIndexRoute
  '/home/': typeof HomeIndexRoute
  '/import/': typeof ImportIndexRoute
  '/login/': typeof LoginIndexRoute
  '/logout/': typeof LogoutIndexRoute
  '/manageAccounts/': typeof ManageAccountsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/preferences/': typeof PreferencesIndexRoute
  '/program/': typeof ProgramIndexRoute
  '/prospecting/': typeof ProspectingIndexRoute
  '/questions/': typeof QuestionsIndexRoute
  '/quiz/': typeof QuizIndexRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/sampleComponents/': typeof SampleComponentsIndexRoute
  '/stats/': typeof StatsIndexRoute
  '/team/': typeof TeamIndexRoute
  '/user/': typeof UserIndexRoute
  '/webhook/': typeof WebhookIndexRoute
  '/dashboard_/$dashboardId_/edit': typeof DashboardDashboardIdEditRouteRouteWithChildren
  '/integration/marketplace_/$appId': typeof IntegrationMarketplaceAppIdRouteRouteWithChildren
  '/account_/$accountId/': typeof AccountAccountIdIndexRoute
  '/account_/add/': typeof AccountAddIndexRoute
  '/areaManagement_/trash/': typeof AreaManagementTrashIndexRoute
  '/attachment/$attachmentId/': typeof AttachmentAttachmentIdIndexRoute
  '/betausers_/$userId/': typeof BetausersUserIdIndexRoute
  '/calendar/$eventId/': typeof CalendarEventIdIndexRoute
  '/calendar_/closerAvailability/': typeof CalendarCloserAvailabilityIndexRoute
  '/chat/$sessionId/': typeof ChatSessionIdIndexRoute
  '/companies_/$companyId/': typeof CompaniesCompanyIdIndexRoute
  '/companies_/add/': typeof CompaniesAddIndexRoute
  '/competition_/add/': typeof CompetitionAddIndexRoute
  '/competition_/trash/': typeof CompetitionTrashIndexRoute
  '/compliance_/policy/': typeof CompliancePolicyIndexRoute
  '/compliance_/violations/': typeof ComplianceViolationsIndexRoute
  '/conversations_/$convoId/': typeof ConversationsConvoIdIndexRoute
  '/conversations_/flagged/': typeof ConversationsFlaggedIndexRoute
  '/conversations_/skillShare/': typeof ConversationsSkillShareIndexRoute
  '/feature_/$featureId/': typeof FeatureFeatureIdIndexRoute
  '/integration/apikey/': typeof IntegrationApikeyIndexRoute
  '/integration/developer/': typeof IntegrationDeveloperIndexRoute
  '/integration/export/': typeof IntegrationExportIndexRoute
  '/integration/import/': typeof IntegrationImportIndexRoute
  '/integration/marketplace/': typeof IntegrationMarketplaceIndexRoute
  '/integration/mcp/': typeof IntegrationMcpIndexRoute
  '/integration/webhook/': typeof IntegrationWebhookIndexRoute
  '/location/audit/': typeof LocationAuditIndexRoute
  '/location/geocode/': typeof LocationGeocodeIndexRoute
  '/program_/trash/': typeof ProgramTrashIndexRoute
  '/questions_/$questionId/': typeof QuestionsQuestionIdIndexRoute
  '/questions_/add/': typeof QuestionsAddIndexRoute
  '/questions_/trash/': typeof QuestionsTrashIndexRoute
  '/quiz_/trash/': typeof QuizTrashIndexRoute
  '/recordings_/$recordingId/': typeof RecordingsRecordingIdIndexRoute
  '/settings/ai/': typeof SettingsAiIndexRoute
  '/settings/apikey/': typeof SettingsApikeyIndexRoute
  '/settings/communicationPreferences/': typeof SettingsCommunicationPreferencesIndexRoute
  '/settings/company/': typeof SettingsCompanyIndexRoute
  '/settings/configuration/': typeof SettingsConfigurationIndexRoute
  '/settings/customField/': typeof SettingsCustomFieldIndexRoute
  '/settings/disposition/': typeof SettingsDispositionIndexRoute
  '/settings/links/': typeof SettingsLinksIndexRoute
  '/settings/myCard/': typeof SettingsMyCardIndexRoute
  '/settings/outcome/': typeof SettingsOutcomeIndexRoute
  '/settings/permissions/': typeof SettingsPermissionsIndexRoute
  '/settings/ratios/': typeof SettingsRatiosIndexRoute
  '/settings/role/': typeof SettingsRoleIndexRoute
  '/settings/scorecard/': typeof SettingsScorecardIndexRoute
  '/settings/status/': typeof SettingsStatusIndexRoute
  '/settings/tile/': typeof SettingsTileIndexRoute
  '/settings/webhook/': typeof SettingsWebhookIndexRoute
  '/settings/workflow/': typeof SettingsWorkflowIndexRoute
  '/short/reports/': typeof ShortReportsIndexRoute
  '/short/upload/': typeof ShortUploadIndexRoute
  '/short_/$videoId/': typeof ShortVideoIdIndexRoute
  '/stats_/map/': typeof StatsMapIndexRoute
  '/sunrun_/oktaUsers/': typeof SunrunOktaUsersIndexRoute
  '/task/management/': typeof TaskManagementIndexRoute
  '/task/managers/': typeof TaskManagersIndexRoute
  '/task/troubleshoot/': typeof TaskTroubleshootIndexRoute
  '/team_/$teamId/': typeof TeamTeamIdIndexRoute
  '/team_/add/': typeof TeamAddIndexRoute
  '/team_/trash/': typeof TeamTrashIndexRoute
  '/user_/$userId/': typeof UserUserIdIndexRoute
  '/user_/add/': typeof UserAddIndexRoute
  '/user_/trash/': typeof UserTrashIndexRoute
  '/betausers_/$userId/edit/': typeof BetausersUserIdEditIndexRoute
  '/companies_/$companyId_/manage/': typeof CompaniesCompanyIdManageIndexRoute
  '/companies_/$companyId_/user/': typeof CompaniesCompanyIdUserIndexRoute
  '/competition_/$gameId/bracket/': typeof CompetitionGameIdBracketIndexRoute
  '/competition_/$gameId/marketing/': typeof CompetitionGameIdMarketingIndexRoute
  '/competition_/$gameId/participant/': typeof CompetitionGameIdParticipantIndexRoute
  '/competition_/$gameId/prize/': typeof CompetitionGameIdPrizeIndexRoute
  '/competition_/$gameId/scoring/': typeof CompetitionGameIdScoringIndexRoute
  '/competition_/$gameId/summary/': typeof CompetitionGameIdSummaryIndexRoute
  '/competition_/$gameId/timeline/': typeof CompetitionGameIdTimelineIndexRoute
  '/competition_/$gameId_/view/': typeof CompetitionGameIdViewIndexRoute
  '/compliance_/policy_/$policyId/': typeof CompliancePolicyPolicyIdIndexRoute
  '/compliance_/policy_/add/': typeof CompliancePolicyAddIndexRoute
  '/compliance_/violation_/$violationId/': typeof ComplianceViolationViolationIdIndexRoute
  '/compliance_/violations_/$entityId/': typeof ComplianceViolationsEntityIdIndexRoute
  '/dashboard_/$dashboardId_/edit/': typeof DashboardDashboardIdEditIndexRoute
  '/integration/developer_/$appId/': typeof IntegrationDeveloperAppIdIndexRoute
  '/integration/import_/$importId/': typeof IntegrationImportImportIdIndexRoute
  '/integration/import_/add/': typeof IntegrationImportAddIndexRoute
  '/integration/marketplace_/$appId/': typeof IntegrationMarketplaceAppIdIndexRoute
  '/integration/webhook_/$webhookId/': typeof IntegrationWebhookWebhookIdIndexRoute
  '/location/list/$customLocationId/': typeof LocationListCustomLocationIdIndexRoute
  '/program_/$programId/setup/': typeof ProgramProgramIdSetupIndexRoute
  '/program_/$programId/summary/': typeof ProgramProgramIdSummaryIndexRoute
  '/program_/$programId/tasks/': typeof ProgramProgramIdTasksIndexRoute
  '/program_/$programId/users/': typeof ProgramProgramIdUsersIndexRoute
  '/program_/$programId_/view/': typeof ProgramProgramIdViewIndexRoute
  '/questions_/$questionId_/edit/': typeof QuestionsQuestionIdEditIndexRoute
  '/quiz_/$quizId/assignees/': typeof QuizQuizIdAssigneesIndexRoute
  '/quiz_/$quizId/questions/': typeof QuizQuizIdQuestionsIndexRoute
  '/quiz_/$quizId/settings/': typeof QuizQuizIdSettingsIndexRoute
  '/quiz_/$quizId/summary/': typeof QuizQuizIdSummaryIndexRoute
  '/settings/company_/user/': typeof SettingsCompanyUserIndexRoute
  '/settings/customField_/$fieldId/': typeof SettingsCustomFieldFieldIdIndexRoute
  '/settings/customField_/add/': typeof SettingsCustomFieldAddIndexRoute
  '/settings/customField_/trash/': typeof SettingsCustomFieldTrashIndexRoute
  '/settings/disposition_/$dispositionId/': typeof SettingsDispositionDispositionIdIndexRoute
  '/settings/disposition_/add/': typeof SettingsDispositionAddIndexRoute
  '/settings/links_/$externalLinkId/': typeof SettingsLinksExternalLinkIdIndexRoute
  '/settings/links_/add/': typeof SettingsLinksAddIndexRoute
  '/settings/outcome_/$outcomeId/': typeof SettingsOutcomeOutcomeIdIndexRoute
  '/settings/outcome_/add/': typeof SettingsOutcomeAddIndexRoute
  '/settings/permissions/compare/': typeof SettingsPermissionsCompareIndexRoute
  '/settings/role/$roleId/': typeof SettingsRoleRoleIdIndexRoute
  '/settings/role/add/': typeof SettingsRoleAddIndexRoute
  '/settings/role/trash/': typeof SettingsRoleTrashIndexRoute
  '/settings/scorecard_/$rubricId/': typeof SettingsScorecardRubricIdIndexRoute
  '/settings/scorecard_/add/': typeof SettingsScorecardAddIndexRoute
  '/settings/scorecard_/trash/': typeof SettingsScorecardTrashIndexRoute
  '/settings/status_/$statusId/': typeof SettingsStatusStatusIdIndexRoute
  '/settings/status_/add/': typeof SettingsStatusAddIndexRoute
  '/settings/workflow_/$workflowId/': typeof SettingsWorkflowWorkflowIdIndexRoute
  '/short/reports_/$videoId/': typeof ShortReportsVideoIdIndexRoute
  '/task/managers_/$managerId/': typeof TaskManagersManagerIdIndexRoute
  '/team_/$teamId_/$userId/': typeof TeamTeamIdUserIdIndexRoute
  '/user_/$userId_/edit/': typeof UserUserIdEditIndexRoute
  '/companies_/$companyId_/user_/$userId/': typeof CompaniesCompanyIdUserUserIdIndexRoute
  '/companies_/$companyId_/user_/add/': typeof CompaniesCompanyIdUserAddIndexRoute
  '/companies_/$companyId_/user_/trash/': typeof CompaniesCompanyIdUserTrashIndexRoute
  '/integration/developer_/$appId_/$scriptId/': typeof IntegrationDeveloperAppIdScriptIdIndexRoute
  '/integration/marketplace_/$appId/$installId/': typeof IntegrationMarketplaceAppIdInstallIdIndexRoute
  '/integration/marketplace_/$appId/documentation/': typeof IntegrationMarketplaceAppIdDocumentationIndexRoute
  '/settings/company_/user_/add/': typeof SettingsCompanyUserAddIndexRoute
  '/settings/company_/user_/trash/': typeof SettingsCompanyUserTrashIndexRoute
  '/team_/$teamId_/$userId/edit/': typeof TeamTeamIdUserIdEditIndexRoute
  '/companies_/$companyId_/user_/$userId_/edit/': typeof CompaniesCompanyIdUserUserIdEditIndexRoute
  '/integration/marketplace_/$appId/$installId_/metrics/': typeof IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/chat'
    | '/integration'
    | '/settings'
    | '/competition/$gameId'
    | '/integration/cli'
    | '/location/list'
    | '/program/$programId'
    | '/quiz/$quizId'
    | '/settings/role'
    | '/account/'
    | '/activity/'
    | '/activityTrail/'
    | '/apikey/'
    | '/area/'
    | '/areaManagement/'
    | '/assignAccounts/'
    | '/betaUsers/'
    | '/calendar/'
    | '/cloneTool/'
    | '/closers/'
    | '/companies/'
    | '/competition/'
    | '/compliance/'
    | '/conversations/'
    | '/dashboard/'
    | '/demo-tools/'
    | '/dnk/'
    | '/export/'
    | '/feature/'
    | '/home/'
    | '/import/'
    | '/login/'
    | '/logout/'
    | '/manageAccounts/'
    | '/notifications/'
    | '/preferences/'
    | '/program/'
    | '/prospecting/'
    | '/questions/'
    | '/quiz/'
    | '/recordings/'
    | '/reports/'
    | '/sampleComponents/'
    | '/stats/'
    | '/team/'
    | '/user/'
    | '/webhook/'
    | '/dashboard/$dashboardId/edit'
    | '/integration/marketplace/$appId'
    | '/account/$accountId/'
    | '/account/add/'
    | '/areaManagement/trash/'
    | '/attachment/$attachmentId/'
    | '/betausers/$userId/'
    | '/calendar/$eventId/'
    | '/calendar/closerAvailability/'
    | '/chat/$sessionId/'
    | '/companies/$companyId/'
    | '/companies/add/'
    | '/competition/add/'
    | '/competition/trash/'
    | '/compliance/policy/'
    | '/compliance/violations/'
    | '/conversations/$convoId/'
    | '/conversations/flagged/'
    | '/conversations/skillShare/'
    | '/feature/$featureId/'
    | '/integration/apikey/'
    | '/integration/developer/'
    | '/integration/export/'
    | '/integration/import/'
    | '/integration/marketplace/'
    | '/integration/mcp/'
    | '/integration/webhook/'
    | '/location/audit/'
    | '/location/geocode/'
    | '/program/trash/'
    | '/questions/$questionId/'
    | '/questions/add/'
    | '/questions/trash/'
    | '/quiz/trash/'
    | '/recordings/$recordingId/'
    | '/settings/ai/'
    | '/settings/apikey/'
    | '/settings/communicationPreferences/'
    | '/settings/company/'
    | '/settings/configuration/'
    | '/settings/customField/'
    | '/settings/disposition/'
    | '/settings/links/'
    | '/settings/myCard/'
    | '/settings/outcome/'
    | '/settings/permissions/'
    | '/settings/ratios/'
    | '/settings/role/'
    | '/settings/scorecard/'
    | '/settings/status/'
    | '/settings/tile/'
    | '/settings/webhook/'
    | '/settings/workflow/'
    | '/short/reports/'
    | '/short/upload/'
    | '/short/$videoId/'
    | '/stats/map/'
    | '/sunrun/oktaUsers/'
    | '/task/management/'
    | '/task/managers/'
    | '/task/troubleshoot/'
    | '/team/$teamId/'
    | '/team/add/'
    | '/team/trash/'
    | '/user/$userId/'
    | '/user/add/'
    | '/user/trash/'
    | '/betausers/$userId/edit/'
    | '/companies/$companyId/manage/'
    | '/companies/$companyId/user/'
    | '/competition/$gameId/bracket/'
    | '/competition/$gameId/marketing/'
    | '/competition/$gameId/participant/'
    | '/competition/$gameId/prize/'
    | '/competition/$gameId/scoring/'
    | '/competition/$gameId/summary/'
    | '/competition/$gameId/timeline/'
    | '/competition/$gameId/view/'
    | '/compliance/policy/$policyId/'
    | '/compliance/policy/add/'
    | '/compliance/violation/$violationId/'
    | '/compliance/violations/$entityId/'
    | '/dashboard/$dashboardId/edit/'
    | '/integration/developer/$appId/'
    | '/integration/import/$importId/'
    | '/integration/import/add/'
    | '/integration/marketplace/$appId/'
    | '/integration/webhook/$webhookId/'
    | '/location/list/$customLocationId/'
    | '/program/$programId/setup/'
    | '/program/$programId/summary/'
    | '/program/$programId/tasks/'
    | '/program/$programId/users/'
    | '/program/$programId/view/'
    | '/questions/$questionId/edit/'
    | '/quiz/$quizId/assignees/'
    | '/quiz/$quizId/questions/'
    | '/quiz/$quizId/settings/'
    | '/quiz/$quizId/summary/'
    | '/settings/company/user/'
    | '/settings/customField/$fieldId/'
    | '/settings/customField/add/'
    | '/settings/customField/trash/'
    | '/settings/disposition/$dispositionId/'
    | '/settings/disposition/add/'
    | '/settings/links/$externalLinkId/'
    | '/settings/links/add/'
    | '/settings/outcome/$outcomeId/'
    | '/settings/outcome/add/'
    | '/settings/permissions/compare/'
    | '/settings/role/$roleId/'
    | '/settings/role/add/'
    | '/settings/role/trash/'
    | '/settings/scorecard/$rubricId/'
    | '/settings/scorecard/add/'
    | '/settings/scorecard/trash/'
    | '/settings/status/$statusId/'
    | '/settings/status/add/'
    | '/settings/workflow/$workflowId/'
    | '/short/reports/$videoId/'
    | '/task/managers/$managerId/'
    | '/team/$teamId/$userId/'
    | '/user/$userId/edit/'
    | '/companies/$companyId/user/$userId/'
    | '/companies/$companyId/user/add/'
    | '/companies/$companyId/user/trash/'
    | '/integration/developer/$appId/$scriptId/'
    | '/integration/marketplace/$appId/$installId/'
    | '/integration/marketplace/$appId/documentation/'
    | '/settings/company/user/add/'
    | '/settings/company/user/trash/'
    | '/team/$teamId/$userId/edit/'
    | '/companies/$companyId/user/$userId/edit/'
    | '/integration/marketplace/$appId/$installId/metrics/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chat'
    | '/integration'
    | '/settings'
    | '/competition/$gameId'
    | '/integration/cli'
    | '/location/list'
    | '/program/$programId'
    | '/quiz/$quizId'
    | '/account'
    | '/activity'
    | '/activityTrail'
    | '/apikey'
    | '/area'
    | '/areaManagement'
    | '/assignAccounts'
    | '/betaUsers'
    | '/calendar'
    | '/cloneTool'
    | '/closers'
    | '/companies'
    | '/competition'
    | '/compliance'
    | '/conversations'
    | '/dashboard'
    | '/demo-tools'
    | '/dnk'
    | '/export'
    | '/feature'
    | '/home'
    | '/import'
    | '/login'
    | '/logout'
    | '/manageAccounts'
    | '/notifications'
    | '/preferences'
    | '/program'
    | '/prospecting'
    | '/questions'
    | '/quiz'
    | '/recordings'
    | '/reports'
    | '/sampleComponents'
    | '/stats'
    | '/team'
    | '/user'
    | '/webhook'
    | '/account/$accountId'
    | '/account/add'
    | '/areaManagement/trash'
    | '/attachment/$attachmentId'
    | '/betausers/$userId'
    | '/calendar/$eventId'
    | '/calendar/closerAvailability'
    | '/chat/$sessionId'
    | '/companies/$companyId'
    | '/companies/add'
    | '/competition/add'
    | '/competition/trash'
    | '/compliance/policy'
    | '/compliance/violations'
    | '/conversations/$convoId'
    | '/conversations/flagged'
    | '/conversations/skillShare'
    | '/feature/$featureId'
    | '/integration/apikey'
    | '/integration/developer'
    | '/integration/export'
    | '/integration/import'
    | '/integration/marketplace'
    | '/integration/mcp'
    | '/integration/webhook'
    | '/location/audit'
    | '/location/geocode'
    | '/program/trash'
    | '/questions/$questionId'
    | '/questions/add'
    | '/questions/trash'
    | '/quiz/trash'
    | '/recordings/$recordingId'
    | '/settings/ai'
    | '/settings/apikey'
    | '/settings/communicationPreferences'
    | '/settings/company'
    | '/settings/configuration'
    | '/settings/customField'
    | '/settings/disposition'
    | '/settings/links'
    | '/settings/myCard'
    | '/settings/outcome'
    | '/settings/permissions'
    | '/settings/ratios'
    | '/settings/role'
    | '/settings/scorecard'
    | '/settings/status'
    | '/settings/tile'
    | '/settings/webhook'
    | '/settings/workflow'
    | '/short/reports'
    | '/short/upload'
    | '/short/$videoId'
    | '/stats/map'
    | '/sunrun/oktaUsers'
    | '/task/management'
    | '/task/managers'
    | '/task/troubleshoot'
    | '/team/$teamId'
    | '/team/add'
    | '/team/trash'
    | '/user/$userId'
    | '/user/add'
    | '/user/trash'
    | '/betausers/$userId/edit'
    | '/companies/$companyId/manage'
    | '/companies/$companyId/user'
    | '/competition/$gameId/bracket'
    | '/competition/$gameId/marketing'
    | '/competition/$gameId/participant'
    | '/competition/$gameId/prize'
    | '/competition/$gameId/scoring'
    | '/competition/$gameId/summary'
    | '/competition/$gameId/timeline'
    | '/competition/$gameId/view'
    | '/compliance/policy/$policyId'
    | '/compliance/policy/add'
    | '/compliance/violation/$violationId'
    | '/compliance/violations/$entityId'
    | '/dashboard/$dashboardId/edit'
    | '/integration/developer/$appId'
    | '/integration/import/$importId'
    | '/integration/import/add'
    | '/integration/marketplace/$appId'
    | '/integration/webhook/$webhookId'
    | '/location/list/$customLocationId'
    | '/program/$programId/setup'
    | '/program/$programId/summary'
    | '/program/$programId/tasks'
    | '/program/$programId/users'
    | '/program/$programId/view'
    | '/questions/$questionId/edit'
    | '/quiz/$quizId/assignees'
    | '/quiz/$quizId/questions'
    | '/quiz/$quizId/settings'
    | '/quiz/$quizId/summary'
    | '/settings/company/user'
    | '/settings/customField/$fieldId'
    | '/settings/customField/add'
    | '/settings/customField/trash'
    | '/settings/disposition/$dispositionId'
    | '/settings/disposition/add'
    | '/settings/links/$externalLinkId'
    | '/settings/links/add'
    | '/settings/outcome/$outcomeId'
    | '/settings/outcome/add'
    | '/settings/permissions/compare'
    | '/settings/role/$roleId'
    | '/settings/role/add'
    | '/settings/role/trash'
    | '/settings/scorecard/$rubricId'
    | '/settings/scorecard/add'
    | '/settings/scorecard/trash'
    | '/settings/status/$statusId'
    | '/settings/status/add'
    | '/settings/workflow/$workflowId'
    | '/short/reports/$videoId'
    | '/task/managers/$managerId'
    | '/team/$teamId/$userId'
    | '/user/$userId/edit'
    | '/companies/$companyId/user/$userId'
    | '/companies/$companyId/user/add'
    | '/companies/$companyId/user/trash'
    | '/integration/developer/$appId/$scriptId'
    | '/integration/marketplace/$appId/$installId'
    | '/integration/marketplace/$appId/documentation'
    | '/settings/company/user/add'
    | '/settings/company/user/trash'
    | '/team/$teamId/$userId/edit'
    | '/companies/$companyId/user/$userId/edit'
    | '/integration/marketplace/$appId/$installId/metrics'
  id:
    | '__root__'
    | '/'
    | '/chat'
    | '/integration'
    | '/settings'
    | '/competition_/$gameId'
    | '/integration/cli'
    | '/location/list'
    | '/program_/$programId'
    | '/quiz_/$quizId'
    | '/settings/role'
    | '/account/'
    | '/activity/'
    | '/activityTrail/'
    | '/apikey/'
    | '/area/'
    | '/areaManagement/'
    | '/assignAccounts/'
    | '/betaUsers/'
    | '/calendar/'
    | '/cloneTool/'
    | '/closers/'
    | '/companies/'
    | '/competition/'
    | '/compliance/'
    | '/conversations/'
    | '/dashboard/'
    | '/demo-tools/'
    | '/dnk/'
    | '/export/'
    | '/feature/'
    | '/home/'
    | '/import/'
    | '/login/'
    | '/logout/'
    | '/manageAccounts/'
    | '/notifications/'
    | '/preferences/'
    | '/program/'
    | '/prospecting/'
    | '/questions/'
    | '/quiz/'
    | '/recordings/'
    | '/reports/'
    | '/sampleComponents/'
    | '/stats/'
    | '/team/'
    | '/user/'
    | '/webhook/'
    | '/dashboard_/$dashboardId_/edit'
    | '/integration/marketplace_/$appId'
    | '/account_/$accountId/'
    | '/account_/add/'
    | '/areaManagement_/trash/'
    | '/attachment/$attachmentId/'
    | '/betausers_/$userId/'
    | '/calendar/$eventId/'
    | '/calendar_/closerAvailability/'
    | '/chat/$sessionId/'
    | '/companies_/$companyId/'
    | '/companies_/add/'
    | '/competition_/add/'
    | '/competition_/trash/'
    | '/compliance_/policy/'
    | '/compliance_/violations/'
    | '/conversations_/$convoId/'
    | '/conversations_/flagged/'
    | '/conversations_/skillShare/'
    | '/feature_/$featureId/'
    | '/integration/apikey/'
    | '/integration/developer/'
    | '/integration/export/'
    | '/integration/import/'
    | '/integration/marketplace/'
    | '/integration/mcp/'
    | '/integration/webhook/'
    | '/location/audit/'
    | '/location/geocode/'
    | '/program_/trash/'
    | '/questions_/$questionId/'
    | '/questions_/add/'
    | '/questions_/trash/'
    | '/quiz_/trash/'
    | '/recordings_/$recordingId/'
    | '/settings/ai/'
    | '/settings/apikey/'
    | '/settings/communicationPreferences/'
    | '/settings/company/'
    | '/settings/configuration/'
    | '/settings/customField/'
    | '/settings/disposition/'
    | '/settings/links/'
    | '/settings/myCard/'
    | '/settings/outcome/'
    | '/settings/permissions/'
    | '/settings/ratios/'
    | '/settings/role/'
    | '/settings/scorecard/'
    | '/settings/status/'
    | '/settings/tile/'
    | '/settings/webhook/'
    | '/settings/workflow/'
    | '/short/reports/'
    | '/short/upload/'
    | '/short_/$videoId/'
    | '/stats_/map/'
    | '/sunrun_/oktaUsers/'
    | '/task/management/'
    | '/task/managers/'
    | '/task/troubleshoot/'
    | '/team_/$teamId/'
    | '/team_/add/'
    | '/team_/trash/'
    | '/user_/$userId/'
    | '/user_/add/'
    | '/user_/trash/'
    | '/betausers_/$userId/edit/'
    | '/companies_/$companyId_/manage/'
    | '/companies_/$companyId_/user/'
    | '/competition_/$gameId/bracket/'
    | '/competition_/$gameId/marketing/'
    | '/competition_/$gameId/participant/'
    | '/competition_/$gameId/prize/'
    | '/competition_/$gameId/scoring/'
    | '/competition_/$gameId/summary/'
    | '/competition_/$gameId/timeline/'
    | '/competition_/$gameId_/view/'
    | '/compliance_/policy_/$policyId/'
    | '/compliance_/policy_/add/'
    | '/compliance_/violation_/$violationId/'
    | '/compliance_/violations_/$entityId/'
    | '/dashboard_/$dashboardId_/edit/'
    | '/integration/developer_/$appId/'
    | '/integration/import_/$importId/'
    | '/integration/import_/add/'
    | '/integration/marketplace_/$appId/'
    | '/integration/webhook_/$webhookId/'
    | '/location/list/$customLocationId/'
    | '/program_/$programId/setup/'
    | '/program_/$programId/summary/'
    | '/program_/$programId/tasks/'
    | '/program_/$programId/users/'
    | '/program_/$programId_/view/'
    | '/questions_/$questionId_/edit/'
    | '/quiz_/$quizId/assignees/'
    | '/quiz_/$quizId/questions/'
    | '/quiz_/$quizId/settings/'
    | '/quiz_/$quizId/summary/'
    | '/settings/company_/user/'
    | '/settings/customField_/$fieldId/'
    | '/settings/customField_/add/'
    | '/settings/customField_/trash/'
    | '/settings/disposition_/$dispositionId/'
    | '/settings/disposition_/add/'
    | '/settings/links_/$externalLinkId/'
    | '/settings/links_/add/'
    | '/settings/outcome_/$outcomeId/'
    | '/settings/outcome_/add/'
    | '/settings/permissions/compare/'
    | '/settings/role/$roleId/'
    | '/settings/role/add/'
    | '/settings/role/trash/'
    | '/settings/scorecard_/$rubricId/'
    | '/settings/scorecard_/add/'
    | '/settings/scorecard_/trash/'
    | '/settings/status_/$statusId/'
    | '/settings/status_/add/'
    | '/settings/workflow_/$workflowId/'
    | '/short/reports_/$videoId/'
    | '/task/managers_/$managerId/'
    | '/team_/$teamId_/$userId/'
    | '/user_/$userId_/edit/'
    | '/companies_/$companyId_/user_/$userId/'
    | '/companies_/$companyId_/user_/add/'
    | '/companies_/$companyId_/user_/trash/'
    | '/integration/developer_/$appId_/$scriptId/'
    | '/integration/marketplace_/$appId/$installId/'
    | '/integration/marketplace_/$appId/documentation/'
    | '/settings/company_/user_/add/'
    | '/settings/company_/user_/trash/'
    | '/team_/$teamId_/$userId/edit/'
    | '/companies_/$companyId_/user_/$userId_/edit/'
    | '/integration/marketplace_/$appId/$installId_/metrics/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChatRouteRoute: typeof ChatRouteRouteWithChildren
  IntegrationRouteRoute: typeof IntegrationRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  CompetitionGameIdRouteRoute: typeof CompetitionGameIdRouteRouteWithChildren
  LocationListRouteRoute: typeof LocationListRouteRouteWithChildren
  ProgramProgramIdRouteRoute: typeof ProgramProgramIdRouteRouteWithChildren
  QuizQuizIdRouteRoute: typeof QuizQuizIdRouteRouteWithChildren
  AccountIndexRoute: typeof AccountIndexRoute
  ActivityIndexRoute: typeof ActivityIndexRoute
  ActivityTrailIndexRoute: typeof ActivityTrailIndexRoute
  ApikeyIndexRoute: typeof ApikeyIndexRoute
  AreaIndexRoute: typeof AreaIndexRoute
  AreaManagementIndexRoute: typeof AreaManagementIndexRoute
  AssignAccountsIndexRoute: typeof AssignAccountsIndexRoute
  BetaUsersIndexRoute: typeof BetaUsersIndexRoute
  CalendarIndexRoute: typeof CalendarIndexRoute
  CloneToolIndexRoute: typeof CloneToolIndexRoute
  ClosersIndexRoute: typeof ClosersIndexRoute
  CompaniesIndexRoute: typeof CompaniesIndexRoute
  CompetitionIndexRoute: typeof CompetitionIndexRoute
  ComplianceIndexRoute: typeof ComplianceIndexRoute
  ConversationsIndexRoute: typeof ConversationsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DemoToolsIndexRoute: typeof DemoToolsIndexRoute
  DnkIndexRoute: typeof DnkIndexRoute
  ExportIndexRoute: typeof ExportIndexRoute
  FeatureIndexRoute: typeof FeatureIndexRoute
  HomeIndexRoute: typeof HomeIndexRoute
  ImportIndexRoute: typeof ImportIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  LogoutIndexRoute: typeof LogoutIndexRoute
  ManageAccountsIndexRoute: typeof ManageAccountsIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  PreferencesIndexRoute: typeof PreferencesIndexRoute
  ProgramIndexRoute: typeof ProgramIndexRoute
  ProspectingIndexRoute: typeof ProspectingIndexRoute
  QuestionsIndexRoute: typeof QuestionsIndexRoute
  QuizIndexRoute: typeof QuizIndexRoute
  RecordingsIndexRoute: typeof RecordingsIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  SampleComponentsIndexRoute: typeof SampleComponentsIndexRoute
  StatsIndexRoute: typeof StatsIndexRoute
  TeamIndexRoute: typeof TeamIndexRoute
  UserIndexRoute: typeof UserIndexRoute
  WebhookIndexRoute: typeof WebhookIndexRoute
  DashboardDashboardIdEditRouteRoute: typeof DashboardDashboardIdEditRouteRouteWithChildren
  AccountAccountIdIndexRoute: typeof AccountAccountIdIndexRoute
  AccountAddIndexRoute: typeof AccountAddIndexRoute
  AreaManagementTrashIndexRoute: typeof AreaManagementTrashIndexRoute
  AttachmentAttachmentIdIndexRoute: typeof AttachmentAttachmentIdIndexRoute
  BetausersUserIdIndexRoute: typeof BetausersUserIdIndexRoute
  CalendarEventIdIndexRoute: typeof CalendarEventIdIndexRoute
  CalendarCloserAvailabilityIndexRoute: typeof CalendarCloserAvailabilityIndexRoute
  CompaniesCompanyIdIndexRoute: typeof CompaniesCompanyIdIndexRoute
  CompaniesAddIndexRoute: typeof CompaniesAddIndexRoute
  CompetitionAddIndexRoute: typeof CompetitionAddIndexRoute
  CompetitionTrashIndexRoute: typeof CompetitionTrashIndexRoute
  CompliancePolicyIndexRoute: typeof CompliancePolicyIndexRoute
  ComplianceViolationsIndexRoute: typeof ComplianceViolationsIndexRoute
  ConversationsConvoIdIndexRoute: typeof ConversationsConvoIdIndexRoute
  ConversationsFlaggedIndexRoute: typeof ConversationsFlaggedIndexRoute
  ConversationsSkillShareIndexRoute: typeof ConversationsSkillShareIndexRoute
  FeatureFeatureIdIndexRoute: typeof FeatureFeatureIdIndexRoute
  LocationAuditIndexRoute: typeof LocationAuditIndexRoute
  LocationGeocodeIndexRoute: typeof LocationGeocodeIndexRoute
  ProgramTrashIndexRoute: typeof ProgramTrashIndexRoute
  QuestionsQuestionIdIndexRoute: typeof QuestionsQuestionIdIndexRoute
  QuestionsAddIndexRoute: typeof QuestionsAddIndexRoute
  QuestionsTrashIndexRoute: typeof QuestionsTrashIndexRoute
  QuizTrashIndexRoute: typeof QuizTrashIndexRoute
  RecordingsRecordingIdIndexRoute: typeof RecordingsRecordingIdIndexRoute
  ShortReportsIndexRoute: typeof ShortReportsIndexRoute
  ShortUploadIndexRoute: typeof ShortUploadIndexRoute
  ShortVideoIdIndexRoute: typeof ShortVideoIdIndexRoute
  StatsMapIndexRoute: typeof StatsMapIndexRoute
  SunrunOktaUsersIndexRoute: typeof SunrunOktaUsersIndexRoute
  TaskManagementIndexRoute: typeof TaskManagementIndexRoute
  TaskManagersIndexRoute: typeof TaskManagersIndexRoute
  TaskTroubleshootIndexRoute: typeof TaskTroubleshootIndexRoute
  TeamTeamIdIndexRoute: typeof TeamTeamIdIndexRoute
  TeamAddIndexRoute: typeof TeamAddIndexRoute
  TeamTrashIndexRoute: typeof TeamTrashIndexRoute
  UserUserIdIndexRoute: typeof UserUserIdIndexRoute
  UserAddIndexRoute: typeof UserAddIndexRoute
  UserTrashIndexRoute: typeof UserTrashIndexRoute
  BetausersUserIdEditIndexRoute: typeof BetausersUserIdEditIndexRoute
  CompaniesCompanyIdManageIndexRoute: typeof CompaniesCompanyIdManageIndexRoute
  CompaniesCompanyIdUserIndexRoute: typeof CompaniesCompanyIdUserIndexRoute
  CompetitionGameIdViewIndexRoute: typeof CompetitionGameIdViewIndexRoute
  CompliancePolicyPolicyIdIndexRoute: typeof CompliancePolicyPolicyIdIndexRoute
  CompliancePolicyAddIndexRoute: typeof CompliancePolicyAddIndexRoute
  ComplianceViolationViolationIdIndexRoute: typeof ComplianceViolationViolationIdIndexRoute
  ComplianceViolationsEntityIdIndexRoute: typeof ComplianceViolationsEntityIdIndexRoute
  ProgramProgramIdViewIndexRoute: typeof ProgramProgramIdViewIndexRoute
  QuestionsQuestionIdEditIndexRoute: typeof QuestionsQuestionIdEditIndexRoute
  ShortReportsVideoIdIndexRoute: typeof ShortReportsVideoIdIndexRoute
  TaskManagersManagerIdIndexRoute: typeof TaskManagersManagerIdIndexRoute
  TeamTeamIdUserIdIndexRoute: typeof TeamTeamIdUserIdIndexRoute
  UserUserIdEditIndexRoute: typeof UserUserIdEditIndexRoute
  CompaniesCompanyIdUserUserIdIndexRoute: typeof CompaniesCompanyIdUserUserIdIndexRoute
  CompaniesCompanyIdUserAddIndexRoute: typeof CompaniesCompanyIdUserAddIndexRoute
  CompaniesCompanyIdUserTrashIndexRoute: typeof CompaniesCompanyIdUserTrashIndexRoute
  TeamTeamIdUserIdEditIndexRoute: typeof TeamTeamIdUserIdEditIndexRoute
  CompaniesCompanyIdUserUserIdEditIndexRoute: typeof CompaniesCompanyIdUserUserIdEditIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration': {
      id: '/integration'
      path: '/integration'
      fullPath: '/integration'
      preLoaderRoute: typeof IntegrationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity/': {
      id: '/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof ActivityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activityTrail/': {
      id: '/activityTrail/'
      path: '/activityTrail'
      fullPath: '/activityTrail/'
      preLoaderRoute: typeof ActivityTrailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apikey/': {
      id: '/apikey/'
      path: '/apikey'
      fullPath: '/apikey/'
      preLoaderRoute: typeof ApikeyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/area/': {
      id: '/area/'
      path: '/area'
      fullPath: '/area/'
      preLoaderRoute: typeof AreaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/areaManagement/': {
      id: '/areaManagement/'
      path: '/areaManagement'
      fullPath: '/areaManagement/'
      preLoaderRoute: typeof AreaManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assignAccounts/': {
      id: '/assignAccounts/'
      path: '/assignAccounts'
      fullPath: '/assignAccounts/'
      preLoaderRoute: typeof AssignAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/betaUsers/': {
      id: '/betaUsers/'
      path: '/betaUsers'
      fullPath: '/betaUsers/'
      preLoaderRoute: typeof BetaUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar/': {
      id: '/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof CalendarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cloneTool/': {
      id: '/cloneTool/'
      path: '/cloneTool'
      fullPath: '/cloneTool/'
      preLoaderRoute: typeof CloneToolIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/closers/': {
      id: '/closers/'
      path: '/closers'
      fullPath: '/closers/'
      preLoaderRoute: typeof ClosersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/': {
      id: '/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof CompaniesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competition/': {
      id: '/competition/'
      path: '/competition'
      fullPath: '/competition/'
      preLoaderRoute: typeof CompetitionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competition_/$gameId': {
      id: '/competition_/$gameId'
      path: '/competition/$gameId'
      fullPath: '/competition/$gameId'
      preLoaderRoute: typeof CompetitionGameIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance/': {
      id: '/compliance/'
      path: '/compliance'
      fullPath: '/compliance/'
      preLoaderRoute: typeof ComplianceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations/': {
      id: '/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof ConversationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo-tools/': {
      id: '/demo-tools/'
      path: '/demo-tools'
      fullPath: '/demo-tools/'
      preLoaderRoute: typeof DemoToolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dnk/': {
      id: '/dnk/'
      path: '/dnk'
      fullPath: '/dnk/'
      preLoaderRoute: typeof DnkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/': {
      id: '/export/'
      path: '/export'
      fullPath: '/export/'
      preLoaderRoute: typeof ExportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feature/': {
      id: '/feature/'
      path: '/feature'
      fullPath: '/feature/'
      preLoaderRoute: typeof FeatureIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/': {
      id: '/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/': {
      id: '/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof ImportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration/cli': {
      id: '/integration/cli'
      path: '/cli'
      fullPath: '/integration/cli'
      preLoaderRoute: typeof IntegrationCliRouteRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/location/list': {
      id: '/location/list'
      path: '/location/list'
      fullPath: '/location/list'
      preLoaderRoute: typeof LocationListRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout/': {
      id: '/logout/'
      path: '/logout'
      fullPath: '/logout/'
      preLoaderRoute: typeof LogoutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manageAccounts/': {
      id: '/manageAccounts/'
      path: '/manageAccounts'
      fullPath: '/manageAccounts/'
      preLoaderRoute: typeof ManageAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preferences/': {
      id: '/preferences/'
      path: '/preferences'
      fullPath: '/preferences/'
      preLoaderRoute: typeof PreferencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/program/': {
      id: '/program/'
      path: '/program'
      fullPath: '/program/'
      preLoaderRoute: typeof ProgramIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/program_/$programId': {
      id: '/program_/$programId'
      path: '/program/$programId'
      fullPath: '/program/$programId'
      preLoaderRoute: typeof ProgramProgramIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prospecting/': {
      id: '/prospecting/'
      path: '/prospecting'
      fullPath: '/prospecting/'
      preLoaderRoute: typeof ProspectingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questions/': {
      id: '/questions/'
      path: '/questions'
      fullPath: '/questions/'
      preLoaderRoute: typeof QuestionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quiz/': {
      id: '/quiz/'
      path: '/quiz'
      fullPath: '/quiz/'
      preLoaderRoute: typeof QuizIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quiz_/$quizId': {
      id: '/quiz_/$quizId'
      path: '/quiz/$quizId'
      fullPath: '/quiz/$quizId'
      preLoaderRoute: typeof QuizQuizIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/': {
      id: '/recordings/'
      path: '/recordings'
      fullPath: '/recordings/'
      preLoaderRoute: typeof RecordingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sampleComponents/': {
      id: '/sampleComponents/'
      path: '/sampleComponents'
      fullPath: '/sampleComponents/'
      preLoaderRoute: typeof SampleComponentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/role': {
      id: '/settings/role'
      path: '/role'
      fullPath: '/settings/role'
      preLoaderRoute: typeof SettingsRoleRouteRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/stats/': {
      id: '/stats/'
      path: '/stats'
      fullPath: '/stats/'
      preLoaderRoute: typeof StatsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/': {
      id: '/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof TeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/': {
      id: '/user/'
      path: '/user'
      fullPath: '/user/'
      preLoaderRoute: typeof UserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhook/': {
      id: '/webhook/'
      path: '/webhook'
      fullPath: '/webhook/'
      preLoaderRoute: typeof WebhookIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account_/$accountId/': {
      id: '/account_/$accountId/'
      path: '/account/$accountId'
      fullPath: '/account/$accountId/'
      preLoaderRoute: typeof AccountAccountIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account_/add/': {
      id: '/account_/add/'
      path: '/account/add'
      fullPath: '/account/add/'
      preLoaderRoute: typeof AccountAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/areaManagement_/trash/': {
      id: '/areaManagement_/trash/'
      path: '/areaManagement/trash'
      fullPath: '/areaManagement/trash/'
      preLoaderRoute: typeof AreaManagementTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attachment/$attachmentId/': {
      id: '/attachment/$attachmentId/'
      path: '/attachment/$attachmentId'
      fullPath: '/attachment/$attachmentId/'
      preLoaderRoute: typeof AttachmentAttachmentIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/betausers_/$userId/': {
      id: '/betausers_/$userId/'
      path: '/betausers/$userId'
      fullPath: '/betausers/$userId/'
      preLoaderRoute: typeof BetausersUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar/$eventId/': {
      id: '/calendar/$eventId/'
      path: '/calendar/$eventId'
      fullPath: '/calendar/$eventId/'
      preLoaderRoute: typeof CalendarEventIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar_/closerAvailability/': {
      id: '/calendar_/closerAvailability/'
      path: '/calendar/closerAvailability'
      fullPath: '/calendar/closerAvailability/'
      preLoaderRoute: typeof CalendarCloserAvailabilityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$sessionId/': {
      id: '/chat/$sessionId/'
      path: '/$sessionId'
      fullPath: '/chat/$sessionId/'
      preLoaderRoute: typeof ChatSessionIdIndexRouteImport
      parentRoute: typeof ChatRouteRoute
    }
    '/companies_/$companyId/': {
      id: '/companies_/$companyId/'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof CompaniesCompanyIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/add/': {
      id: '/companies_/add/'
      path: '/companies/add'
      fullPath: '/companies/add/'
      preLoaderRoute: typeof CompaniesAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competition_/add/': {
      id: '/competition_/add/'
      path: '/competition/add'
      fullPath: '/competition/add/'
      preLoaderRoute: typeof CompetitionAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competition_/trash/': {
      id: '/competition_/trash/'
      path: '/competition/trash'
      fullPath: '/competition/trash/'
      preLoaderRoute: typeof CompetitionTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance_/policy/': {
      id: '/compliance_/policy/'
      path: '/compliance/policy'
      fullPath: '/compliance/policy/'
      preLoaderRoute: typeof CompliancePolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance_/violations/': {
      id: '/compliance_/violations/'
      path: '/compliance/violations'
      fullPath: '/compliance/violations/'
      preLoaderRoute: typeof ComplianceViolationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations_/$convoId/': {
      id: '/conversations_/$convoId/'
      path: '/conversations/$convoId'
      fullPath: '/conversations/$convoId/'
      preLoaderRoute: typeof ConversationsConvoIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations_/flagged/': {
      id: '/conversations_/flagged/'
      path: '/conversations/flagged'
      fullPath: '/conversations/flagged/'
      preLoaderRoute: typeof ConversationsFlaggedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations_/skillShare/': {
      id: '/conversations_/skillShare/'
      path: '/conversations/skillShare'
      fullPath: '/conversations/skillShare/'
      preLoaderRoute: typeof ConversationsSkillShareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard_/$dashboardId_/edit': {
      id: '/dashboard_/$dashboardId_/edit'
      path: '/dashboard/$dashboardId/edit'
      fullPath: '/dashboard/$dashboardId/edit'
      preLoaderRoute: typeof DashboardDashboardIdEditRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feature_/$featureId/': {
      id: '/feature_/$featureId/'
      path: '/feature/$featureId'
      fullPath: '/feature/$featureId/'
      preLoaderRoute: typeof FeatureFeatureIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration/apikey/': {
      id: '/integration/apikey/'
      path: '/apikey'
      fullPath: '/integration/apikey/'
      preLoaderRoute: typeof IntegrationApikeyIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/developer/': {
      id: '/integration/developer/'
      path: '/developer'
      fullPath: '/integration/developer/'
      preLoaderRoute: typeof IntegrationDeveloperIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/export/': {
      id: '/integration/export/'
      path: '/export'
      fullPath: '/integration/export/'
      preLoaderRoute: typeof IntegrationExportIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/import/': {
      id: '/integration/import/'
      path: '/import'
      fullPath: '/integration/import/'
      preLoaderRoute: typeof IntegrationImportIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/marketplace/': {
      id: '/integration/marketplace/'
      path: '/marketplace'
      fullPath: '/integration/marketplace/'
      preLoaderRoute: typeof IntegrationMarketplaceIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/marketplace_/$appId': {
      id: '/integration/marketplace_/$appId'
      path: '/marketplace/$appId'
      fullPath: '/integration/marketplace/$appId'
      preLoaderRoute: typeof IntegrationMarketplaceAppIdRouteRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/mcp/': {
      id: '/integration/mcp/'
      path: '/mcp'
      fullPath: '/integration/mcp/'
      preLoaderRoute: typeof IntegrationMcpIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/webhook/': {
      id: '/integration/webhook/'
      path: '/webhook'
      fullPath: '/integration/webhook/'
      preLoaderRoute: typeof IntegrationWebhookIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/location/audit/': {
      id: '/location/audit/'
      path: '/location/audit'
      fullPath: '/location/audit/'
      preLoaderRoute: typeof LocationAuditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/location/geocode/': {
      id: '/location/geocode/'
      path: '/location/geocode'
      fullPath: '/location/geocode/'
      preLoaderRoute: typeof LocationGeocodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/program_/trash/': {
      id: '/program_/trash/'
      path: '/program/trash'
      fullPath: '/program/trash/'
      preLoaderRoute: typeof ProgramTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questions_/$questionId/': {
      id: '/questions_/$questionId/'
      path: '/questions/$questionId'
      fullPath: '/questions/$questionId/'
      preLoaderRoute: typeof QuestionsQuestionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questions_/add/': {
      id: '/questions_/add/'
      path: '/questions/add'
      fullPath: '/questions/add/'
      preLoaderRoute: typeof QuestionsAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questions_/trash/': {
      id: '/questions_/trash/'
      path: '/questions/trash'
      fullPath: '/questions/trash/'
      preLoaderRoute: typeof QuestionsTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quiz_/trash/': {
      id: '/quiz_/trash/'
      path: '/quiz/trash'
      fullPath: '/quiz/trash/'
      preLoaderRoute: typeof QuizTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings_/$recordingId/': {
      id: '/recordings_/$recordingId/'
      path: '/recordings/$recordingId'
      fullPath: '/recordings/$recordingId/'
      preLoaderRoute: typeof RecordingsRecordingIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ai/': {
      id: '/settings/ai/'
      path: '/ai'
      fullPath: '/settings/ai/'
      preLoaderRoute: typeof SettingsAiIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/apikey/': {
      id: '/settings/apikey/'
      path: '/apikey'
      fullPath: '/settings/apikey/'
      preLoaderRoute: typeof SettingsApikeyIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/communicationPreferences/': {
      id: '/settings/communicationPreferences/'
      path: '/communicationPreferences'
      fullPath: '/settings/communicationPreferences/'
      preLoaderRoute: typeof SettingsCommunicationPreferencesIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/company/': {
      id: '/settings/company/'
      path: '/company'
      fullPath: '/settings/company/'
      preLoaderRoute: typeof SettingsCompanyIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/configuration/': {
      id: '/settings/configuration/'
      path: '/configuration'
      fullPath: '/settings/configuration/'
      preLoaderRoute: typeof SettingsConfigurationIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/customField/': {
      id: '/settings/customField/'
      path: '/customField'
      fullPath: '/settings/customField/'
      preLoaderRoute: typeof SettingsCustomFieldIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/disposition/': {
      id: '/settings/disposition/'
      path: '/disposition'
      fullPath: '/settings/disposition/'
      preLoaderRoute: typeof SettingsDispositionIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/links/': {
      id: '/settings/links/'
      path: '/links'
      fullPath: '/settings/links/'
      preLoaderRoute: typeof SettingsLinksIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/myCard/': {
      id: '/settings/myCard/'
      path: '/myCard'
      fullPath: '/settings/myCard/'
      preLoaderRoute: typeof SettingsMyCardIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/outcome/': {
      id: '/settings/outcome/'
      path: '/outcome'
      fullPath: '/settings/outcome/'
      preLoaderRoute: typeof SettingsOutcomeIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/permissions/': {
      id: '/settings/permissions/'
      path: '/permissions'
      fullPath: '/settings/permissions/'
      preLoaderRoute: typeof SettingsPermissionsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/ratios/': {
      id: '/settings/ratios/'
      path: '/ratios'
      fullPath: '/settings/ratios/'
      preLoaderRoute: typeof SettingsRatiosIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/role/': {
      id: '/settings/role/'
      path: '/'
      fullPath: '/settings/role/'
      preLoaderRoute: typeof SettingsRoleIndexRouteImport
      parentRoute: typeof SettingsRoleRouteRoute
    }
    '/settings/scorecard/': {
      id: '/settings/scorecard/'
      path: '/scorecard'
      fullPath: '/settings/scorecard/'
      preLoaderRoute: typeof SettingsScorecardIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/status/': {
      id: '/settings/status/'
      path: '/status'
      fullPath: '/settings/status/'
      preLoaderRoute: typeof SettingsStatusIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/tile/': {
      id: '/settings/tile/'
      path: '/tile'
      fullPath: '/settings/tile/'
      preLoaderRoute: typeof SettingsTileIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/webhook/': {
      id: '/settings/webhook/'
      path: '/webhook'
      fullPath: '/settings/webhook/'
      preLoaderRoute: typeof SettingsWebhookIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/workflow/': {
      id: '/settings/workflow/'
      path: '/workflow'
      fullPath: '/settings/workflow/'
      preLoaderRoute: typeof SettingsWorkflowIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/short/reports/': {
      id: '/short/reports/'
      path: '/short/reports'
      fullPath: '/short/reports/'
      preLoaderRoute: typeof ShortReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/short/upload/': {
      id: '/short/upload/'
      path: '/short/upload'
      fullPath: '/short/upload/'
      preLoaderRoute: typeof ShortUploadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/short_/$videoId/': {
      id: '/short_/$videoId/'
      path: '/short/$videoId'
      fullPath: '/short/$videoId/'
      preLoaderRoute: typeof ShortVideoIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats_/map/': {
      id: '/stats_/map/'
      path: '/stats/map'
      fullPath: '/stats/map/'
      preLoaderRoute: typeof StatsMapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sunrun_/oktaUsers/': {
      id: '/sunrun_/oktaUsers/'
      path: '/sunrun/oktaUsers'
      fullPath: '/sunrun/oktaUsers/'
      preLoaderRoute: typeof SunrunOktaUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/task/management/': {
      id: '/task/management/'
      path: '/task/management'
      fullPath: '/task/management/'
      preLoaderRoute: typeof TaskManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/task/managers/': {
      id: '/task/managers/'
      path: '/task/managers'
      fullPath: '/task/managers/'
      preLoaderRoute: typeof TaskManagersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/task/troubleshoot/': {
      id: '/task/troubleshoot/'
      path: '/task/troubleshoot'
      fullPath: '/task/troubleshoot/'
      preLoaderRoute: typeof TaskTroubleshootIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team_/$teamId/': {
      id: '/team_/$teamId/'
      path: '/team/$teamId'
      fullPath: '/team/$teamId/'
      preLoaderRoute: typeof TeamTeamIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team_/add/': {
      id: '/team_/add/'
      path: '/team/add'
      fullPath: '/team/add/'
      preLoaderRoute: typeof TeamAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team_/trash/': {
      id: '/team_/trash/'
      path: '/team/trash'
      fullPath: '/team/trash/'
      preLoaderRoute: typeof TeamTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user_/$userId/': {
      id: '/user_/$userId/'
      path: '/user/$userId'
      fullPath: '/user/$userId/'
      preLoaderRoute: typeof UserUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user_/add/': {
      id: '/user_/add/'
      path: '/user/add'
      fullPath: '/user/add/'
      preLoaderRoute: typeof UserAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user_/trash/': {
      id: '/user_/trash/'
      path: '/user/trash'
      fullPath: '/user/trash/'
      preLoaderRoute: typeof UserTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/betausers_/$userId/edit/': {
      id: '/betausers_/$userId/edit/'
      path: '/betausers/$userId/edit'
      fullPath: '/betausers/$userId/edit/'
      preLoaderRoute: typeof BetausersUserIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId_/manage/': {
      id: '/companies_/$companyId_/manage/'
      path: '/companies/$companyId/manage'
      fullPath: '/companies/$companyId/manage/'
      preLoaderRoute: typeof CompaniesCompanyIdManageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId_/user/': {
      id: '/companies_/$companyId_/user/'
      path: '/companies/$companyId/user'
      fullPath: '/companies/$companyId/user/'
      preLoaderRoute: typeof CompaniesCompanyIdUserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competition_/$gameId/bracket/': {
      id: '/competition_/$gameId/bracket/'
      path: '/bracket'
      fullPath: '/competition/$gameId/bracket/'
      preLoaderRoute: typeof CompetitionGameIdBracketIndexRouteImport
      parentRoute: typeof CompetitionGameIdRouteRoute
    }
    '/competition_/$gameId/marketing/': {
      id: '/competition_/$gameId/marketing/'
      path: '/marketing'
      fullPath: '/competition/$gameId/marketing/'
      preLoaderRoute: typeof CompetitionGameIdMarketingIndexRouteImport
      parentRoute: typeof CompetitionGameIdRouteRoute
    }
    '/competition_/$gameId/participant/': {
      id: '/competition_/$gameId/participant/'
      path: '/participant'
      fullPath: '/competition/$gameId/participant/'
      preLoaderRoute: typeof CompetitionGameIdParticipantIndexRouteImport
      parentRoute: typeof CompetitionGameIdRouteRoute
    }
    '/competition_/$gameId/prize/': {
      id: '/competition_/$gameId/prize/'
      path: '/prize'
      fullPath: '/competition/$gameId/prize/'
      preLoaderRoute: typeof CompetitionGameIdPrizeIndexRouteImport
      parentRoute: typeof CompetitionGameIdRouteRoute
    }
    '/competition_/$gameId/scoring/': {
      id: '/competition_/$gameId/scoring/'
      path: '/scoring'
      fullPath: '/competition/$gameId/scoring/'
      preLoaderRoute: typeof CompetitionGameIdScoringIndexRouteImport
      parentRoute: typeof CompetitionGameIdRouteRoute
    }
    '/competition_/$gameId/summary/': {
      id: '/competition_/$gameId/summary/'
      path: '/summary'
      fullPath: '/competition/$gameId/summary/'
      preLoaderRoute: typeof CompetitionGameIdSummaryIndexRouteImport
      parentRoute: typeof CompetitionGameIdRouteRoute
    }
    '/competition_/$gameId/timeline/': {
      id: '/competition_/$gameId/timeline/'
      path: '/timeline'
      fullPath: '/competition/$gameId/timeline/'
      preLoaderRoute: typeof CompetitionGameIdTimelineIndexRouteImport
      parentRoute: typeof CompetitionGameIdRouteRoute
    }
    '/competition_/$gameId_/view/': {
      id: '/competition_/$gameId_/view/'
      path: '/competition/$gameId/view'
      fullPath: '/competition/$gameId/view/'
      preLoaderRoute: typeof CompetitionGameIdViewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance_/policy_/$policyId/': {
      id: '/compliance_/policy_/$policyId/'
      path: '/compliance/policy/$policyId'
      fullPath: '/compliance/policy/$policyId/'
      preLoaderRoute: typeof CompliancePolicyPolicyIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance_/policy_/add/': {
      id: '/compliance_/policy_/add/'
      path: '/compliance/policy/add'
      fullPath: '/compliance/policy/add/'
      preLoaderRoute: typeof CompliancePolicyAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance_/violation_/$violationId/': {
      id: '/compliance_/violation_/$violationId/'
      path: '/compliance/violation/$violationId'
      fullPath: '/compliance/violation/$violationId/'
      preLoaderRoute: typeof ComplianceViolationViolationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance_/violations_/$entityId/': {
      id: '/compliance_/violations_/$entityId/'
      path: '/compliance/violations/$entityId'
      fullPath: '/compliance/violations/$entityId/'
      preLoaderRoute: typeof ComplianceViolationsEntityIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard_/$dashboardId_/edit/': {
      id: '/dashboard_/$dashboardId_/edit/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/edit/'
      preLoaderRoute: typeof DashboardDashboardIdEditIndexRouteImport
      parentRoute: typeof DashboardDashboardIdEditRouteRoute
    }
    '/integration/developer_/$appId/': {
      id: '/integration/developer_/$appId/'
      path: '/developer/$appId'
      fullPath: '/integration/developer/$appId/'
      preLoaderRoute: typeof IntegrationDeveloperAppIdIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/import_/$importId/': {
      id: '/integration/import_/$importId/'
      path: '/import/$importId'
      fullPath: '/integration/import/$importId/'
      preLoaderRoute: typeof IntegrationImportImportIdIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/import_/add/': {
      id: '/integration/import_/add/'
      path: '/import/add'
      fullPath: '/integration/import/add/'
      preLoaderRoute: typeof IntegrationImportAddIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/marketplace_/$appId/': {
      id: '/integration/marketplace_/$appId/'
      path: '/'
      fullPath: '/integration/marketplace/$appId/'
      preLoaderRoute: typeof IntegrationMarketplaceAppIdIndexRouteImport
      parentRoute: typeof IntegrationMarketplaceAppIdRouteRoute
    }
    '/integration/webhook_/$webhookId/': {
      id: '/integration/webhook_/$webhookId/'
      path: '/webhook/$webhookId'
      fullPath: '/integration/webhook/$webhookId/'
      preLoaderRoute: typeof IntegrationWebhookWebhookIdIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/location/list/$customLocationId/': {
      id: '/location/list/$customLocationId/'
      path: '/$customLocationId'
      fullPath: '/location/list/$customLocationId/'
      preLoaderRoute: typeof LocationListCustomLocationIdIndexRouteImport
      parentRoute: typeof LocationListRouteRoute
    }
    '/program_/$programId/setup/': {
      id: '/program_/$programId/setup/'
      path: '/setup'
      fullPath: '/program/$programId/setup/'
      preLoaderRoute: typeof ProgramProgramIdSetupIndexRouteImport
      parentRoute: typeof ProgramProgramIdRouteRoute
    }
    '/program_/$programId/summary/': {
      id: '/program_/$programId/summary/'
      path: '/summary'
      fullPath: '/program/$programId/summary/'
      preLoaderRoute: typeof ProgramProgramIdSummaryIndexRouteImport
      parentRoute: typeof ProgramProgramIdRouteRoute
    }
    '/program_/$programId/tasks/': {
      id: '/program_/$programId/tasks/'
      path: '/tasks'
      fullPath: '/program/$programId/tasks/'
      preLoaderRoute: typeof ProgramProgramIdTasksIndexRouteImport
      parentRoute: typeof ProgramProgramIdRouteRoute
    }
    '/program_/$programId/users/': {
      id: '/program_/$programId/users/'
      path: '/users'
      fullPath: '/program/$programId/users/'
      preLoaderRoute: typeof ProgramProgramIdUsersIndexRouteImport
      parentRoute: typeof ProgramProgramIdRouteRoute
    }
    '/program_/$programId_/view/': {
      id: '/program_/$programId_/view/'
      path: '/program/$programId/view'
      fullPath: '/program/$programId/view/'
      preLoaderRoute: typeof ProgramProgramIdViewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questions_/$questionId_/edit/': {
      id: '/questions_/$questionId_/edit/'
      path: '/questions/$questionId/edit'
      fullPath: '/questions/$questionId/edit/'
      preLoaderRoute: typeof QuestionsQuestionIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quiz_/$quizId/assignees/': {
      id: '/quiz_/$quizId/assignees/'
      path: '/assignees'
      fullPath: '/quiz/$quizId/assignees/'
      preLoaderRoute: typeof QuizQuizIdAssigneesIndexRouteImport
      parentRoute: typeof QuizQuizIdRouteRoute
    }
    '/quiz_/$quizId/questions/': {
      id: '/quiz_/$quizId/questions/'
      path: '/questions'
      fullPath: '/quiz/$quizId/questions/'
      preLoaderRoute: typeof QuizQuizIdQuestionsIndexRouteImport
      parentRoute: typeof QuizQuizIdRouteRoute
    }
    '/quiz_/$quizId/settings/': {
      id: '/quiz_/$quizId/settings/'
      path: '/settings'
      fullPath: '/quiz/$quizId/settings/'
      preLoaderRoute: typeof QuizQuizIdSettingsIndexRouteImport
      parentRoute: typeof QuizQuizIdRouteRoute
    }
    '/quiz_/$quizId/summary/': {
      id: '/quiz_/$quizId/summary/'
      path: '/summary'
      fullPath: '/quiz/$quizId/summary/'
      preLoaderRoute: typeof QuizQuizIdSummaryIndexRouteImport
      parentRoute: typeof QuizQuizIdRouteRoute
    }
    '/settings/company_/user/': {
      id: '/settings/company_/user/'
      path: '/company/user'
      fullPath: '/settings/company/user/'
      preLoaderRoute: typeof SettingsCompanyUserIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/customField_/$fieldId/': {
      id: '/settings/customField_/$fieldId/'
      path: '/customField/$fieldId'
      fullPath: '/settings/customField/$fieldId/'
      preLoaderRoute: typeof SettingsCustomFieldFieldIdIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/customField_/add/': {
      id: '/settings/customField_/add/'
      path: '/customField/add'
      fullPath: '/settings/customField/add/'
      preLoaderRoute: typeof SettingsCustomFieldAddIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/customField_/trash/': {
      id: '/settings/customField_/trash/'
      path: '/customField/trash'
      fullPath: '/settings/customField/trash/'
      preLoaderRoute: typeof SettingsCustomFieldTrashIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/disposition_/$dispositionId/': {
      id: '/settings/disposition_/$dispositionId/'
      path: '/disposition/$dispositionId'
      fullPath: '/settings/disposition/$dispositionId/'
      preLoaderRoute: typeof SettingsDispositionDispositionIdIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/disposition_/add/': {
      id: '/settings/disposition_/add/'
      path: '/disposition/add'
      fullPath: '/settings/disposition/add/'
      preLoaderRoute: typeof SettingsDispositionAddIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/links_/$externalLinkId/': {
      id: '/settings/links_/$externalLinkId/'
      path: '/links/$externalLinkId'
      fullPath: '/settings/links/$externalLinkId/'
      preLoaderRoute: typeof SettingsLinksExternalLinkIdIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/links_/add/': {
      id: '/settings/links_/add/'
      path: '/links/add'
      fullPath: '/settings/links/add/'
      preLoaderRoute: typeof SettingsLinksAddIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/outcome_/$outcomeId/': {
      id: '/settings/outcome_/$outcomeId/'
      path: '/outcome/$outcomeId'
      fullPath: '/settings/outcome/$outcomeId/'
      preLoaderRoute: typeof SettingsOutcomeOutcomeIdIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/outcome_/add/': {
      id: '/settings/outcome_/add/'
      path: '/outcome/add'
      fullPath: '/settings/outcome/add/'
      preLoaderRoute: typeof SettingsOutcomeAddIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/permissions/compare/': {
      id: '/settings/permissions/compare/'
      path: '/permissions/compare'
      fullPath: '/settings/permissions/compare/'
      preLoaderRoute: typeof SettingsPermissionsCompareIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/role/$roleId/': {
      id: '/settings/role/$roleId/'
      path: '/$roleId'
      fullPath: '/settings/role/$roleId/'
      preLoaderRoute: typeof SettingsRoleRoleIdIndexRouteImport
      parentRoute: typeof SettingsRoleRouteRoute
    }
    '/settings/role/add/': {
      id: '/settings/role/add/'
      path: '/add'
      fullPath: '/settings/role/add/'
      preLoaderRoute: typeof SettingsRoleAddIndexRouteImport
      parentRoute: typeof SettingsRoleRouteRoute
    }
    '/settings/role/trash/': {
      id: '/settings/role/trash/'
      path: '/trash'
      fullPath: '/settings/role/trash/'
      preLoaderRoute: typeof SettingsRoleTrashIndexRouteImport
      parentRoute: typeof SettingsRoleRouteRoute
    }
    '/settings/scorecard_/$rubricId/': {
      id: '/settings/scorecard_/$rubricId/'
      path: '/scorecard/$rubricId'
      fullPath: '/settings/scorecard/$rubricId/'
      preLoaderRoute: typeof SettingsScorecardRubricIdIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/scorecard_/add/': {
      id: '/settings/scorecard_/add/'
      path: '/scorecard/add'
      fullPath: '/settings/scorecard/add/'
      preLoaderRoute: typeof SettingsScorecardAddIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/scorecard_/trash/': {
      id: '/settings/scorecard_/trash/'
      path: '/scorecard/trash'
      fullPath: '/settings/scorecard/trash/'
      preLoaderRoute: typeof SettingsScorecardTrashIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/status_/$statusId/': {
      id: '/settings/status_/$statusId/'
      path: '/status/$statusId'
      fullPath: '/settings/status/$statusId/'
      preLoaderRoute: typeof SettingsStatusStatusIdIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/status_/add/': {
      id: '/settings/status_/add/'
      path: '/status/add'
      fullPath: '/settings/status/add/'
      preLoaderRoute: typeof SettingsStatusAddIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/workflow_/$workflowId/': {
      id: '/settings/workflow_/$workflowId/'
      path: '/workflow/$workflowId'
      fullPath: '/settings/workflow/$workflowId/'
      preLoaderRoute: typeof SettingsWorkflowWorkflowIdIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/short/reports_/$videoId/': {
      id: '/short/reports_/$videoId/'
      path: '/short/reports/$videoId'
      fullPath: '/short/reports/$videoId/'
      preLoaderRoute: typeof ShortReportsVideoIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/task/managers_/$managerId/': {
      id: '/task/managers_/$managerId/'
      path: '/task/managers/$managerId'
      fullPath: '/task/managers/$managerId/'
      preLoaderRoute: typeof TaskManagersManagerIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team_/$teamId_/$userId/': {
      id: '/team_/$teamId_/$userId/'
      path: '/team/$teamId/$userId'
      fullPath: '/team/$teamId/$userId/'
      preLoaderRoute: typeof TeamTeamIdUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user_/$userId_/edit/': {
      id: '/user_/$userId_/edit/'
      path: '/user/$userId/edit'
      fullPath: '/user/$userId/edit/'
      preLoaderRoute: typeof UserUserIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId_/user_/$userId/': {
      id: '/companies_/$companyId_/user_/$userId/'
      path: '/companies/$companyId/user/$userId'
      fullPath: '/companies/$companyId/user/$userId/'
      preLoaderRoute: typeof CompaniesCompanyIdUserUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId_/user_/add/': {
      id: '/companies_/$companyId_/user_/add/'
      path: '/companies/$companyId/user/add'
      fullPath: '/companies/$companyId/user/add/'
      preLoaderRoute: typeof CompaniesCompanyIdUserAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId_/user_/trash/': {
      id: '/companies_/$companyId_/user_/trash/'
      path: '/companies/$companyId/user/trash'
      fullPath: '/companies/$companyId/user/trash/'
      preLoaderRoute: typeof CompaniesCompanyIdUserTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration/developer_/$appId_/$scriptId/': {
      id: '/integration/developer_/$appId_/$scriptId/'
      path: '/developer/$appId/$scriptId'
      fullPath: '/integration/developer/$appId/$scriptId/'
      preLoaderRoute: typeof IntegrationDeveloperAppIdScriptIdIndexRouteImport
      parentRoute: typeof IntegrationRouteRoute
    }
    '/integration/marketplace_/$appId/$installId/': {
      id: '/integration/marketplace_/$appId/$installId/'
      path: '/$installId'
      fullPath: '/integration/marketplace/$appId/$installId/'
      preLoaderRoute: typeof IntegrationMarketplaceAppIdInstallIdIndexRouteImport
      parentRoute: typeof IntegrationMarketplaceAppIdRouteRoute
    }
    '/integration/marketplace_/$appId/documentation/': {
      id: '/integration/marketplace_/$appId/documentation/'
      path: '/documentation'
      fullPath: '/integration/marketplace/$appId/documentation/'
      preLoaderRoute: typeof IntegrationMarketplaceAppIdDocumentationIndexRouteImport
      parentRoute: typeof IntegrationMarketplaceAppIdRouteRoute
    }
    '/settings/company_/user_/add/': {
      id: '/settings/company_/user_/add/'
      path: '/company/user/add'
      fullPath: '/settings/company/user/add/'
      preLoaderRoute: typeof SettingsCompanyUserAddIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/company_/user_/trash/': {
      id: '/settings/company_/user_/trash/'
      path: '/company/user/trash'
      fullPath: '/settings/company/user/trash/'
      preLoaderRoute: typeof SettingsCompanyUserTrashIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/team_/$teamId_/$userId/edit/': {
      id: '/team_/$teamId_/$userId/edit/'
      path: '/team/$teamId/$userId/edit'
      fullPath: '/team/$teamId/$userId/edit/'
      preLoaderRoute: typeof TeamTeamIdUserIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId_/user_/$userId_/edit/': {
      id: '/companies_/$companyId_/user_/$userId_/edit/'
      path: '/companies/$companyId/user/$userId/edit'
      fullPath: '/companies/$companyId/user/$userId/edit/'
      preLoaderRoute: typeof CompaniesCompanyIdUserUserIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration/marketplace_/$appId/$installId_/metrics/': {
      id: '/integration/marketplace_/$appId/$installId_/metrics/'
      path: '/$installId/metrics'
      fullPath: '/integration/marketplace/$appId/$installId/metrics/'
      preLoaderRoute: typeof IntegrationMarketplaceAppIdInstallIdMetricsIndexRouteImport
      parentRoute: typeof IntegrationMarketplaceAppIdRouteRoute
    }
  }
}

interface ChatRouteRouteChildren {
  ChatSessionIdIndexRoute: typeof ChatSessionIdIndexRoute
}

const ChatRouteRouteChildren: ChatRouteRouteChildren = {
  ChatSessionIdIndexRoute: ChatSessionIdIndexRoute,
}

const ChatRouteRouteWithChildren = ChatRouteRoute._addFileChildren(
  ChatRouteRouteChildren,
)

interface IntegrationMarketplaceAppIdRouteRouteChildren {
  IntegrationMarketplaceAppIdIndexRoute: typeof IntegrationMarketplaceAppIdIndexRoute
  IntegrationMarketplaceAppIdInstallIdIndexRoute: typeof IntegrationMarketplaceAppIdInstallIdIndexRoute
  IntegrationMarketplaceAppIdDocumentationIndexRoute: typeof IntegrationMarketplaceAppIdDocumentationIndexRoute
  IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute: typeof IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute
}

const IntegrationMarketplaceAppIdRouteRouteChildren: IntegrationMarketplaceAppIdRouteRouteChildren =
  {
    IntegrationMarketplaceAppIdIndexRoute:
      IntegrationMarketplaceAppIdIndexRoute,
    IntegrationMarketplaceAppIdInstallIdIndexRoute:
      IntegrationMarketplaceAppIdInstallIdIndexRoute,
    IntegrationMarketplaceAppIdDocumentationIndexRoute:
      IntegrationMarketplaceAppIdDocumentationIndexRoute,
    IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute:
      IntegrationMarketplaceAppIdInstallIdMetricsIndexRoute,
  }

const IntegrationMarketplaceAppIdRouteRouteWithChildren =
  IntegrationMarketplaceAppIdRouteRoute._addFileChildren(
    IntegrationMarketplaceAppIdRouteRouteChildren,
  )

interface IntegrationRouteRouteChildren {
  IntegrationCliRouteRoute: typeof IntegrationCliRouteRoute
  IntegrationMarketplaceAppIdRouteRoute: typeof IntegrationMarketplaceAppIdRouteRouteWithChildren
  IntegrationApikeyIndexRoute: typeof IntegrationApikeyIndexRoute
  IntegrationDeveloperIndexRoute: typeof IntegrationDeveloperIndexRoute
  IntegrationExportIndexRoute: typeof IntegrationExportIndexRoute
  IntegrationImportIndexRoute: typeof IntegrationImportIndexRoute
  IntegrationMarketplaceIndexRoute: typeof IntegrationMarketplaceIndexRoute
  IntegrationMcpIndexRoute: typeof IntegrationMcpIndexRoute
  IntegrationWebhookIndexRoute: typeof IntegrationWebhookIndexRoute
  IntegrationDeveloperAppIdIndexRoute: typeof IntegrationDeveloperAppIdIndexRoute
  IntegrationImportImportIdIndexRoute: typeof IntegrationImportImportIdIndexRoute
  IntegrationImportAddIndexRoute: typeof IntegrationImportAddIndexRoute
  IntegrationWebhookWebhookIdIndexRoute: typeof IntegrationWebhookWebhookIdIndexRoute
  IntegrationDeveloperAppIdScriptIdIndexRoute: typeof IntegrationDeveloperAppIdScriptIdIndexRoute
}

const IntegrationRouteRouteChildren: IntegrationRouteRouteChildren = {
  IntegrationCliRouteRoute: IntegrationCliRouteRoute,
  IntegrationMarketplaceAppIdRouteRoute:
    IntegrationMarketplaceAppIdRouteRouteWithChildren,
  IntegrationApikeyIndexRoute: IntegrationApikeyIndexRoute,
  IntegrationDeveloperIndexRoute: IntegrationDeveloperIndexRoute,
  IntegrationExportIndexRoute: IntegrationExportIndexRoute,
  IntegrationImportIndexRoute: IntegrationImportIndexRoute,
  IntegrationMarketplaceIndexRoute: IntegrationMarketplaceIndexRoute,
  IntegrationMcpIndexRoute: IntegrationMcpIndexRoute,
  IntegrationWebhookIndexRoute: IntegrationWebhookIndexRoute,
  IntegrationDeveloperAppIdIndexRoute: IntegrationDeveloperAppIdIndexRoute,
  IntegrationImportImportIdIndexRoute: IntegrationImportImportIdIndexRoute,
  IntegrationImportAddIndexRoute: IntegrationImportAddIndexRoute,
  IntegrationWebhookWebhookIdIndexRoute: IntegrationWebhookWebhookIdIndexRoute,
  IntegrationDeveloperAppIdScriptIdIndexRoute:
    IntegrationDeveloperAppIdScriptIdIndexRoute,
}

const IntegrationRouteRouteWithChildren =
  IntegrationRouteRoute._addFileChildren(IntegrationRouteRouteChildren)

interface SettingsRoleRouteRouteChildren {
  SettingsRoleIndexRoute: typeof SettingsRoleIndexRoute
  SettingsRoleRoleIdIndexRoute: typeof SettingsRoleRoleIdIndexRoute
  SettingsRoleAddIndexRoute: typeof SettingsRoleAddIndexRoute
  SettingsRoleTrashIndexRoute: typeof SettingsRoleTrashIndexRoute
}

const SettingsRoleRouteRouteChildren: SettingsRoleRouteRouteChildren = {
  SettingsRoleIndexRoute: SettingsRoleIndexRoute,
  SettingsRoleRoleIdIndexRoute: SettingsRoleRoleIdIndexRoute,
  SettingsRoleAddIndexRoute: SettingsRoleAddIndexRoute,
  SettingsRoleTrashIndexRoute: SettingsRoleTrashIndexRoute,
}

const SettingsRoleRouteRouteWithChildren =
  SettingsRoleRouteRoute._addFileChildren(SettingsRoleRouteRouteChildren)

interface SettingsRouteRouteChildren {
  SettingsRoleRouteRoute: typeof SettingsRoleRouteRouteWithChildren
  SettingsAiIndexRoute: typeof SettingsAiIndexRoute
  SettingsApikeyIndexRoute: typeof SettingsApikeyIndexRoute
  SettingsCommunicationPreferencesIndexRoute: typeof SettingsCommunicationPreferencesIndexRoute
  SettingsCompanyIndexRoute: typeof SettingsCompanyIndexRoute
  SettingsConfigurationIndexRoute: typeof SettingsConfigurationIndexRoute
  SettingsCustomFieldIndexRoute: typeof SettingsCustomFieldIndexRoute
  SettingsDispositionIndexRoute: typeof SettingsDispositionIndexRoute
  SettingsLinksIndexRoute: typeof SettingsLinksIndexRoute
  SettingsMyCardIndexRoute: typeof SettingsMyCardIndexRoute
  SettingsOutcomeIndexRoute: typeof SettingsOutcomeIndexRoute
  SettingsPermissionsIndexRoute: typeof SettingsPermissionsIndexRoute
  SettingsRatiosIndexRoute: typeof SettingsRatiosIndexRoute
  SettingsScorecardIndexRoute: typeof SettingsScorecardIndexRoute
  SettingsStatusIndexRoute: typeof SettingsStatusIndexRoute
  SettingsTileIndexRoute: typeof SettingsTileIndexRoute
  SettingsWebhookIndexRoute: typeof SettingsWebhookIndexRoute
  SettingsWorkflowIndexRoute: typeof SettingsWorkflowIndexRoute
  SettingsCompanyUserIndexRoute: typeof SettingsCompanyUserIndexRoute
  SettingsCustomFieldFieldIdIndexRoute: typeof SettingsCustomFieldFieldIdIndexRoute
  SettingsCustomFieldAddIndexRoute: typeof SettingsCustomFieldAddIndexRoute
  SettingsCustomFieldTrashIndexRoute: typeof SettingsCustomFieldTrashIndexRoute
  SettingsDispositionDispositionIdIndexRoute: typeof SettingsDispositionDispositionIdIndexRoute
  SettingsDispositionAddIndexRoute: typeof SettingsDispositionAddIndexRoute
  SettingsLinksExternalLinkIdIndexRoute: typeof SettingsLinksExternalLinkIdIndexRoute
  SettingsLinksAddIndexRoute: typeof SettingsLinksAddIndexRoute
  SettingsOutcomeOutcomeIdIndexRoute: typeof SettingsOutcomeOutcomeIdIndexRoute
  SettingsOutcomeAddIndexRoute: typeof SettingsOutcomeAddIndexRoute
  SettingsPermissionsCompareIndexRoute: typeof SettingsPermissionsCompareIndexRoute
  SettingsScorecardRubricIdIndexRoute: typeof SettingsScorecardRubricIdIndexRoute
  SettingsScorecardAddIndexRoute: typeof SettingsScorecardAddIndexRoute
  SettingsScorecardTrashIndexRoute: typeof SettingsScorecardTrashIndexRoute
  SettingsStatusStatusIdIndexRoute: typeof SettingsStatusStatusIdIndexRoute
  SettingsStatusAddIndexRoute: typeof SettingsStatusAddIndexRoute
  SettingsWorkflowWorkflowIdIndexRoute: typeof SettingsWorkflowWorkflowIdIndexRoute
  SettingsCompanyUserAddIndexRoute: typeof SettingsCompanyUserAddIndexRoute
  SettingsCompanyUserTrashIndexRoute: typeof SettingsCompanyUserTrashIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsRoleRouteRoute: SettingsRoleRouteRouteWithChildren,
  SettingsAiIndexRoute: SettingsAiIndexRoute,
  SettingsApikeyIndexRoute: SettingsApikeyIndexRoute,
  SettingsCommunicationPreferencesIndexRoute:
    SettingsCommunicationPreferencesIndexRoute,
  SettingsCompanyIndexRoute: SettingsCompanyIndexRoute,
  SettingsConfigurationIndexRoute: SettingsConfigurationIndexRoute,
  SettingsCustomFieldIndexRoute: SettingsCustomFieldIndexRoute,
  SettingsDispositionIndexRoute: SettingsDispositionIndexRoute,
  SettingsLinksIndexRoute: SettingsLinksIndexRoute,
  SettingsMyCardIndexRoute: SettingsMyCardIndexRoute,
  SettingsOutcomeIndexRoute: SettingsOutcomeIndexRoute,
  SettingsPermissionsIndexRoute: SettingsPermissionsIndexRoute,
  SettingsRatiosIndexRoute: SettingsRatiosIndexRoute,
  SettingsScorecardIndexRoute: SettingsScorecardIndexRoute,
  SettingsStatusIndexRoute: SettingsStatusIndexRoute,
  SettingsTileIndexRoute: SettingsTileIndexRoute,
  SettingsWebhookIndexRoute: SettingsWebhookIndexRoute,
  SettingsWorkflowIndexRoute: SettingsWorkflowIndexRoute,
  SettingsCompanyUserIndexRoute: SettingsCompanyUserIndexRoute,
  SettingsCustomFieldFieldIdIndexRoute: SettingsCustomFieldFieldIdIndexRoute,
  SettingsCustomFieldAddIndexRoute: SettingsCustomFieldAddIndexRoute,
  SettingsCustomFieldTrashIndexRoute: SettingsCustomFieldTrashIndexRoute,
  SettingsDispositionDispositionIdIndexRoute:
    SettingsDispositionDispositionIdIndexRoute,
  SettingsDispositionAddIndexRoute: SettingsDispositionAddIndexRoute,
  SettingsLinksExternalLinkIdIndexRoute: SettingsLinksExternalLinkIdIndexRoute,
  SettingsLinksAddIndexRoute: SettingsLinksAddIndexRoute,
  SettingsOutcomeOutcomeIdIndexRoute: SettingsOutcomeOutcomeIdIndexRoute,
  SettingsOutcomeAddIndexRoute: SettingsOutcomeAddIndexRoute,
  SettingsPermissionsCompareIndexRoute: SettingsPermissionsCompareIndexRoute,
  SettingsScorecardRubricIdIndexRoute: SettingsScorecardRubricIdIndexRoute,
  SettingsScorecardAddIndexRoute: SettingsScorecardAddIndexRoute,
  SettingsScorecardTrashIndexRoute: SettingsScorecardTrashIndexRoute,
  SettingsStatusStatusIdIndexRoute: SettingsStatusStatusIdIndexRoute,
  SettingsStatusAddIndexRoute: SettingsStatusAddIndexRoute,
  SettingsWorkflowWorkflowIdIndexRoute: SettingsWorkflowWorkflowIdIndexRoute,
  SettingsCompanyUserAddIndexRoute: SettingsCompanyUserAddIndexRoute,
  SettingsCompanyUserTrashIndexRoute: SettingsCompanyUserTrashIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface CompetitionGameIdRouteRouteChildren {
  CompetitionGameIdBracketIndexRoute: typeof CompetitionGameIdBracketIndexRoute
  CompetitionGameIdMarketingIndexRoute: typeof CompetitionGameIdMarketingIndexRoute
  CompetitionGameIdParticipantIndexRoute: typeof CompetitionGameIdParticipantIndexRoute
  CompetitionGameIdPrizeIndexRoute: typeof CompetitionGameIdPrizeIndexRoute
  CompetitionGameIdScoringIndexRoute: typeof CompetitionGameIdScoringIndexRoute
  CompetitionGameIdSummaryIndexRoute: typeof CompetitionGameIdSummaryIndexRoute
  CompetitionGameIdTimelineIndexRoute: typeof CompetitionGameIdTimelineIndexRoute
}

const CompetitionGameIdRouteRouteChildren: CompetitionGameIdRouteRouteChildren =
  {
    CompetitionGameIdBracketIndexRoute: CompetitionGameIdBracketIndexRoute,
    CompetitionGameIdMarketingIndexRoute: CompetitionGameIdMarketingIndexRoute,
    CompetitionGameIdParticipantIndexRoute:
      CompetitionGameIdParticipantIndexRoute,
    CompetitionGameIdPrizeIndexRoute: CompetitionGameIdPrizeIndexRoute,
    CompetitionGameIdScoringIndexRoute: CompetitionGameIdScoringIndexRoute,
    CompetitionGameIdSummaryIndexRoute: CompetitionGameIdSummaryIndexRoute,
    CompetitionGameIdTimelineIndexRoute: CompetitionGameIdTimelineIndexRoute,
  }

const CompetitionGameIdRouteRouteWithChildren =
  CompetitionGameIdRouteRoute._addFileChildren(
    CompetitionGameIdRouteRouteChildren,
  )

interface LocationListRouteRouteChildren {
  LocationListCustomLocationIdIndexRoute: typeof LocationListCustomLocationIdIndexRoute
}

const LocationListRouteRouteChildren: LocationListRouteRouteChildren = {
  LocationListCustomLocationIdIndexRoute:
    LocationListCustomLocationIdIndexRoute,
}

const LocationListRouteRouteWithChildren =
  LocationListRouteRoute._addFileChildren(LocationListRouteRouteChildren)

interface ProgramProgramIdRouteRouteChildren {
  ProgramProgramIdSetupIndexRoute: typeof ProgramProgramIdSetupIndexRoute
  ProgramProgramIdSummaryIndexRoute: typeof ProgramProgramIdSummaryIndexRoute
  ProgramProgramIdTasksIndexRoute: typeof ProgramProgramIdTasksIndexRoute
  ProgramProgramIdUsersIndexRoute: typeof ProgramProgramIdUsersIndexRoute
}

const ProgramProgramIdRouteRouteChildren: ProgramProgramIdRouteRouteChildren = {
  ProgramProgramIdSetupIndexRoute: ProgramProgramIdSetupIndexRoute,
  ProgramProgramIdSummaryIndexRoute: ProgramProgramIdSummaryIndexRoute,
  ProgramProgramIdTasksIndexRoute: ProgramProgramIdTasksIndexRoute,
  ProgramProgramIdUsersIndexRoute: ProgramProgramIdUsersIndexRoute,
}

const ProgramProgramIdRouteRouteWithChildren =
  ProgramProgramIdRouteRoute._addFileChildren(
    ProgramProgramIdRouteRouteChildren,
  )

interface QuizQuizIdRouteRouteChildren {
  QuizQuizIdAssigneesIndexRoute: typeof QuizQuizIdAssigneesIndexRoute
  QuizQuizIdQuestionsIndexRoute: typeof QuizQuizIdQuestionsIndexRoute
  QuizQuizIdSettingsIndexRoute: typeof QuizQuizIdSettingsIndexRoute
  QuizQuizIdSummaryIndexRoute: typeof QuizQuizIdSummaryIndexRoute
}

const QuizQuizIdRouteRouteChildren: QuizQuizIdRouteRouteChildren = {
  QuizQuizIdAssigneesIndexRoute: QuizQuizIdAssigneesIndexRoute,
  QuizQuizIdQuestionsIndexRoute: QuizQuizIdQuestionsIndexRoute,
  QuizQuizIdSettingsIndexRoute: QuizQuizIdSettingsIndexRoute,
  QuizQuizIdSummaryIndexRoute: QuizQuizIdSummaryIndexRoute,
}

const QuizQuizIdRouteRouteWithChildren = QuizQuizIdRouteRoute._addFileChildren(
  QuizQuizIdRouteRouteChildren,
)

interface DashboardDashboardIdEditRouteRouteChildren {
  DashboardDashboardIdEditIndexRoute: typeof DashboardDashboardIdEditIndexRoute
}

const DashboardDashboardIdEditRouteRouteChildren: DashboardDashboardIdEditRouteRouteChildren =
  {
    DashboardDashboardIdEditIndexRoute: DashboardDashboardIdEditIndexRoute,
  }

const DashboardDashboardIdEditRouteRouteWithChildren =
  DashboardDashboardIdEditRouteRoute._addFileChildren(
    DashboardDashboardIdEditRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChatRouteRoute: ChatRouteRouteWithChildren,
  IntegrationRouteRoute: IntegrationRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  CompetitionGameIdRouteRoute: CompetitionGameIdRouteRouteWithChildren,
  LocationListRouteRoute: LocationListRouteRouteWithChildren,
  ProgramProgramIdRouteRoute: ProgramProgramIdRouteRouteWithChildren,
  QuizQuizIdRouteRoute: QuizQuizIdRouteRouteWithChildren,
  AccountIndexRoute: AccountIndexRoute,
  ActivityIndexRoute: ActivityIndexRoute,
  ActivityTrailIndexRoute: ActivityTrailIndexRoute,
  ApikeyIndexRoute: ApikeyIndexRoute,
  AreaIndexRoute: AreaIndexRoute,
  AreaManagementIndexRoute: AreaManagementIndexRoute,
  AssignAccountsIndexRoute: AssignAccountsIndexRoute,
  BetaUsersIndexRoute: BetaUsersIndexRoute,
  CalendarIndexRoute: CalendarIndexRoute,
  CloneToolIndexRoute: CloneToolIndexRoute,
  ClosersIndexRoute: ClosersIndexRoute,
  CompaniesIndexRoute: CompaniesIndexRoute,
  CompetitionIndexRoute: CompetitionIndexRoute,
  ComplianceIndexRoute: ComplianceIndexRoute,
  ConversationsIndexRoute: ConversationsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DemoToolsIndexRoute: DemoToolsIndexRoute,
  DnkIndexRoute: DnkIndexRoute,
  ExportIndexRoute: ExportIndexRoute,
  FeatureIndexRoute: FeatureIndexRoute,
  HomeIndexRoute: HomeIndexRoute,
  ImportIndexRoute: ImportIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  LogoutIndexRoute: LogoutIndexRoute,
  ManageAccountsIndexRoute: ManageAccountsIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  PreferencesIndexRoute: PreferencesIndexRoute,
  ProgramIndexRoute: ProgramIndexRoute,
  ProspectingIndexRoute: ProspectingIndexRoute,
  QuestionsIndexRoute: QuestionsIndexRoute,
  QuizIndexRoute: QuizIndexRoute,
  RecordingsIndexRoute: RecordingsIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  SampleComponentsIndexRoute: SampleComponentsIndexRoute,
  StatsIndexRoute: StatsIndexRoute,
  TeamIndexRoute: TeamIndexRoute,
  UserIndexRoute: UserIndexRoute,
  WebhookIndexRoute: WebhookIndexRoute,
  DashboardDashboardIdEditRouteRoute:
    DashboardDashboardIdEditRouteRouteWithChildren,
  AccountAccountIdIndexRoute: AccountAccountIdIndexRoute,
  AccountAddIndexRoute: AccountAddIndexRoute,
  AreaManagementTrashIndexRoute: AreaManagementTrashIndexRoute,
  AttachmentAttachmentIdIndexRoute: AttachmentAttachmentIdIndexRoute,
  BetausersUserIdIndexRoute: BetausersUserIdIndexRoute,
  CalendarEventIdIndexRoute: CalendarEventIdIndexRoute,
  CalendarCloserAvailabilityIndexRoute: CalendarCloserAvailabilityIndexRoute,
  CompaniesCompanyIdIndexRoute: CompaniesCompanyIdIndexRoute,
  CompaniesAddIndexRoute: CompaniesAddIndexRoute,
  CompetitionAddIndexRoute: CompetitionAddIndexRoute,
  CompetitionTrashIndexRoute: CompetitionTrashIndexRoute,
  CompliancePolicyIndexRoute: CompliancePolicyIndexRoute,
  ComplianceViolationsIndexRoute: ComplianceViolationsIndexRoute,
  ConversationsConvoIdIndexRoute: ConversationsConvoIdIndexRoute,
  ConversationsFlaggedIndexRoute: ConversationsFlaggedIndexRoute,
  ConversationsSkillShareIndexRoute: ConversationsSkillShareIndexRoute,
  FeatureFeatureIdIndexRoute: FeatureFeatureIdIndexRoute,
  LocationAuditIndexRoute: LocationAuditIndexRoute,
  LocationGeocodeIndexRoute: LocationGeocodeIndexRoute,
  ProgramTrashIndexRoute: ProgramTrashIndexRoute,
  QuestionsQuestionIdIndexRoute: QuestionsQuestionIdIndexRoute,
  QuestionsAddIndexRoute: QuestionsAddIndexRoute,
  QuestionsTrashIndexRoute: QuestionsTrashIndexRoute,
  QuizTrashIndexRoute: QuizTrashIndexRoute,
  RecordingsRecordingIdIndexRoute: RecordingsRecordingIdIndexRoute,
  ShortReportsIndexRoute: ShortReportsIndexRoute,
  ShortUploadIndexRoute: ShortUploadIndexRoute,
  ShortVideoIdIndexRoute: ShortVideoIdIndexRoute,
  StatsMapIndexRoute: StatsMapIndexRoute,
  SunrunOktaUsersIndexRoute: SunrunOktaUsersIndexRoute,
  TaskManagementIndexRoute: TaskManagementIndexRoute,
  TaskManagersIndexRoute: TaskManagersIndexRoute,
  TaskTroubleshootIndexRoute: TaskTroubleshootIndexRoute,
  TeamTeamIdIndexRoute: TeamTeamIdIndexRoute,
  TeamAddIndexRoute: TeamAddIndexRoute,
  TeamTrashIndexRoute: TeamTrashIndexRoute,
  UserUserIdIndexRoute: UserUserIdIndexRoute,
  UserAddIndexRoute: UserAddIndexRoute,
  UserTrashIndexRoute: UserTrashIndexRoute,
  BetausersUserIdEditIndexRoute: BetausersUserIdEditIndexRoute,
  CompaniesCompanyIdManageIndexRoute: CompaniesCompanyIdManageIndexRoute,
  CompaniesCompanyIdUserIndexRoute: CompaniesCompanyIdUserIndexRoute,
  CompetitionGameIdViewIndexRoute: CompetitionGameIdViewIndexRoute,
  CompliancePolicyPolicyIdIndexRoute: CompliancePolicyPolicyIdIndexRoute,
  CompliancePolicyAddIndexRoute: CompliancePolicyAddIndexRoute,
  ComplianceViolationViolationIdIndexRoute:
    ComplianceViolationViolationIdIndexRoute,
  ComplianceViolationsEntityIdIndexRoute:
    ComplianceViolationsEntityIdIndexRoute,
  ProgramProgramIdViewIndexRoute: ProgramProgramIdViewIndexRoute,
  QuestionsQuestionIdEditIndexRoute: QuestionsQuestionIdEditIndexRoute,
  ShortReportsVideoIdIndexRoute: ShortReportsVideoIdIndexRoute,
  TaskManagersManagerIdIndexRoute: TaskManagersManagerIdIndexRoute,
  TeamTeamIdUserIdIndexRoute: TeamTeamIdUserIdIndexRoute,
  UserUserIdEditIndexRoute: UserUserIdEditIndexRoute,
  CompaniesCompanyIdUserUserIdIndexRoute:
    CompaniesCompanyIdUserUserIdIndexRoute,
  CompaniesCompanyIdUserAddIndexRoute: CompaniesCompanyIdUserAddIndexRoute,
  CompaniesCompanyIdUserTrashIndexRoute: CompaniesCompanyIdUserTrashIndexRoute,
  TeamTeamIdUserIdEditIndexRoute: TeamTeamIdUserIdEditIndexRoute,
  CompaniesCompanyIdUserUserIdEditIndexRoute:
    CompaniesCompanyIdUserUserIdEditIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
